import { computed, provide, onScopeDispose, toRef, shallowRef, ref, inject, nextTick, onBeforeUnmount, watch, reactive, onMounted, onUpdated, unref, readonly, watchEffect, effectScope, mergeProps, toRaw, warn, Teleport, Transition, defineComponent, resolveComponent, openBlock, createBlock, createSlots, withCtx, createVNode, renderSlot, normalizeProps, guardReactiveProps } from "vue";
import { u as useDefaults, _ as _export_sfc } from "../_plugin-vue_export-helper-3194dc60.mjs";
import { R as isOn, Y as eventName, p as propsFactory, I as IconValue, i as deepEqual, m as makeComponentProps, k as makeDensityProps, e as makeThemeProps, a as genericComponent, H as getUid, w as provideDefaults, u as useRender, r as useDensity, G as wrapInArray, c as useTextColor, q as useBackgroundColor, W as filterInputAttrs, F as VIcon, Z as matchesSelector, o as omit, B as getCurrentInstanceName, _ as mergeDeep, Q as clamp, $ as consoleWarn, a0 as refElement, g as getCurrentInstance, a1 as findChildrenWithProvide, a2 as templateRef, K as IN_BROWSER, b as makeTagProps, a3 as focusableChildren, f as provideTheme, E as EventProp, n as makeRoundedProps, C as makeSizeProps, v as useRounded, D as useSize, V as VDefaultsProvider, a4 as destructComputed, a5 as consoleError, h as convertToUnit, a6 as defer, l as makeDimensionProps, y as makeTransitionProps, s as useDimension, M as MaybeTransition, a7 as isClickInsideElement, x as focusChild, a8 as getNextElement, a9 as debounce, aa as ensureValidVNode, j as getPropertyFromItem, ab as noop } from "../_density-8094aebe.mjs";
import { m as makeVariantProps, u as useVariant, g as genOverlays, V as VAvatar } from "../MalarkeyContactAvatar-1b079ba3.mjs";
import { V as VLabel, m as makeVInputProps, u as useFocus, a as VInput, b as useRtl, c as useLocale, p as parseAnchor, f as flipSide, d as flipAlign, e as flipCorner, g as getAxis, h as forwardRefs, i as makeVTextFieldProps, j as useForm, k as VTextField } from "../_VTextField-74fe2c1a.mjs";
import { u as useProxiedModel, a as useToggleScope } from "../_proxiedModel-031e293c.mjs";
import { R as Ripple, d as makeBorderProps, e as makeElevationProps, j as makeRouterProps, f as useBorder, g as useElevation, k as useLink, l as createSimpleFunctional, n as useRouter, o as useBackButton, V as VListItem } from "../_VListItem-508e4b13.mjs";
import { d as VFadeTransition, c as VExpandXTransition, g as getTargetBox, B as Box, e as getOverflow, n as nullifyTransforms, b as animate, s as standardEasing, f as VDialogTransition } from "../index-dbde2d54.mjs";
import { m as makeItemsProps, u as useItems, V as VList } from "../_VList-61c79735.mjs";
import { c as instance } from "../malarkeyTwilioAdapter-1c296255.mjs";
import { s as stringOr } from "../helpers-674591c1.mjs";
import MalarkeyContactSearchItem from "./constituants/MalarkeyContactSearchItem.es.js";
import { g as getProxiedModelRef } from "../_internal-8e885689.mjs";
import "../i18n-35335a5c.mjs";
import { b as boundUseI18n } from "../_i18n-e414d464.mjs";
import "../index-fd2245c5.mjs";
import "../_commonjsHelpers-ca272635.mjs";
import "../index-13be80af.mjs";
import "../_debug-8b5c3032.mjs";
import "joi";
import "../MalarkeyContactSearchItem.vue_vue_type_script_lang-f1ada97c.mjs";
import "../_common-fcf3ef61.mjs";
import "../index-38c53cf2.mjs";
import "../index-64135f7d.mjs";
import "../index-703c58ee.mjs";
import "../event-socket/malarkeyEventSocketAdapter.es.js";
import "../otpauth.esm-675c01d0.mjs";
import "../sudo-bad5b55e.mjs";
import "../_ui-71f9b37c.mjs";
import "../_patches-94e7586e.mjs";
const handlers = /* @__PURE__ */ new WeakMap();
function bindProps(el, props) {
  Object.keys(props).forEach((k) => {
    var _a;
    if (isOn(k)) {
      const name = eventName(k);
      const handler = handlers.get(el);
      if (props[k] == null) {
        handler == null ? void 0 : handler.forEach((v) => {
          const [n, fn] = v;
          if (n === name) {
            el.removeEventListener(name, fn);
            handler.delete(v);
          }
        });
      } else if (!handler || !((_a = [...handler]) == null ? void 0 : _a.some((v) => v[0] === name && v[1] === props[k]))) {
        el.addEventListener(name, props[k]);
        const _handler = handler || /* @__PURE__ */ new Set();
        _handler.add([name, props[k]]);
        if (!handlers.has(el))
          handlers.set(el, _handler);
      }
    } else {
      if (props[k] == null) {
        el.removeAttribute(k);
      } else {
        el.setAttribute(k, props[k]);
      }
    }
  });
}
function unbindProps(el, props) {
  Object.keys(props).forEach((k) => {
    if (isOn(k)) {
      const name = eventName(k);
      const handler = handlers.get(el);
      handler == null ? void 0 : handler.forEach((v) => {
        const [n, fn] = v;
        if (n === name) {
          el.removeEventListener(name, fn);
          handler.delete(v);
        }
      });
    } else {
      el.removeAttribute(k);
    }
  });
}
function attachedRoot(node) {
  if (typeof node.getRootNode !== "function") {
    while (node.parentNode)
      node = node.parentNode;
    if (node !== document)
      return null;
    return document;
  }
  const root = node.getRootNode();
  if (root !== document && root.getRootNode({ composed: true }) !== document)
    return null;
  return root;
}
function getScrollParent(el, includeHidden = false) {
  while (el) {
    if (includeHidden ? isPotentiallyScrollable(el) : hasScrollbar(el))
      return el;
    el = el.parentElement;
  }
  return document.scrollingElement;
}
function getScrollParents(el, stopAt) {
  const elements = [];
  if (stopAt && el && !stopAt.contains(el))
    return elements;
  while (el) {
    if (hasScrollbar(el))
      elements.push(el);
    if (el === stopAt)
      break;
    el = el.parentElement;
  }
  return elements;
}
function hasScrollbar(el) {
  if (!el || el.nodeType !== Node.ELEMENT_NODE)
    return false;
  const style = window.getComputedStyle(el);
  return style.overflowY === "scroll" || style.overflowY === "auto" && el.scrollHeight > el.clientHeight;
}
function isPotentiallyScrollable(el) {
  if (!el || el.nodeType !== Node.ELEMENT_NODE)
    return false;
  const style = window.getComputedStyle(el);
  return ["scroll", "auto"].includes(style.overflowY);
}
function isFixedPosition(el) {
  while (el) {
    if (window.getComputedStyle(el).position === "fixed") {
      return true;
    }
    el = el.offsetParent;
  }
  return false;
}
const _VAutocomplete = "";
const _VCheckbox = "";
const _VSelectionControl = "";
const _VSelectionControlGroup = "";
const VSelectionControlGroupSymbol = Symbol.for("vuetify:selection-control-group");
const makeSelectionControlGroupProps = propsFactory({
  color: String,
  disabled: {
    type: Boolean,
    default: null
  },
  defaultsTarget: String,
  error: Boolean,
  id: String,
  inline: Boolean,
  falseIcon: IconValue,
  trueIcon: IconValue,
  ripple: {
    type: [Boolean, Object],
    default: true
  },
  multiple: {
    type: Boolean,
    default: null
  },
  name: String,
  readonly: {
    type: Boolean,
    default: null
  },
  modelValue: null,
  type: String,
  valueComparator: {
    type: Function,
    default: deepEqual
  },
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeThemeProps()
}, "SelectionControlGroup");
const makeVSelectionControlGroupProps = propsFactory({
  ...makeSelectionControlGroupProps({
    defaultsTarget: "VSelectionControl"
  })
}, "VSelectionControlGroup");
genericComponent()({
  name: "VSelectionControlGroup",
  props: makeVSelectionControlGroupProps(),
  emits: {
    "update:modelValue": (value) => true
  },
  setup(props, { slots }) {
    const modelValue = useProxiedModel(props, "modelValue");
    const uid = getUid();
    const id = computed(() => props.id || `v-selection-control-group-${uid}`);
    const name = computed(() => props.name || id.value);
    const updateHandlers = /* @__PURE__ */ new Set();
    provide(VSelectionControlGroupSymbol, {
      modelValue,
      forceUpdate: () => {
        updateHandlers.forEach((fn) => fn());
      },
      onForceUpdate: (cb) => {
        updateHandlers.add(cb);
        onScopeDispose(() => {
          updateHandlers.delete(cb);
        });
      }
    });
    provideDefaults({
      [props.defaultsTarget]: {
        color: toRef(props, "color"),
        disabled: toRef(props, "disabled"),
        density: toRef(props, "density"),
        error: toRef(props, "error"),
        inline: toRef(props, "inline"),
        modelValue,
        multiple: computed(() => !!props.multiple || props.multiple == null && Array.isArray(modelValue.value)),
        name,
        falseIcon: toRef(props, "falseIcon"),
        trueIcon: toRef(props, "trueIcon"),
        readonly: toRef(props, "readonly"),
        ripple: toRef(props, "ripple"),
        type: toRef(props, "type"),
        valueComparator: toRef(props, "valueComparator")
      }
    });
    useRender(() => {
      var _a;
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          class: [
            "v-selection-control-group",
            { "v-selection-control-group--inline": props.inline },
            props.class
          ],
          style: props.style,
          role: props.type === "radio" ? "radiogroup" : void 0
        },
        (_a = slots.default) == null ? void 0 : _a.call(slots)
      );
    });
    return {};
  }
});
const makeVSelectionControlProps = propsFactory({
  label: String,
  baseColor: String,
  trueValue: null,
  falseValue: null,
  value: null,
  ...makeComponentProps(),
  ...makeSelectionControlGroupProps()
}, "VSelectionControl");
function useSelectionControl(props) {
  const group = inject(VSelectionControlGroupSymbol, void 0);
  const { densityClasses } = useDensity(props);
  const modelValue = useProxiedModel(props, "modelValue");
  const trueValue = computed(() => props.trueValue !== void 0 ? props.trueValue : props.value !== void 0 ? props.value : true);
  const falseValue = computed(() => props.falseValue !== void 0 ? props.falseValue : false);
  const isMultiple = computed(() => !!props.multiple || props.multiple == null && Array.isArray(modelValue.value));
  const model = computed({
    get() {
      const val = group ? group.modelValue.value : modelValue.value;
      return isMultiple.value ? wrapInArray(val).some((v) => props.valueComparator(v, trueValue.value)) : props.valueComparator(val, trueValue.value);
    },
    set(val) {
      if (props.readonly)
        return;
      const currentValue = val ? trueValue.value : falseValue.value;
      let newVal = currentValue;
      if (isMultiple.value) {
        newVal = val ? [...wrapInArray(modelValue.value), currentValue] : wrapInArray(modelValue.value).filter((item) => !props.valueComparator(item, trueValue.value));
      }
      if (group) {
        group.modelValue.value = newVal;
      } else {
        modelValue.value = newVal;
      }
    }
  });
  const { textColorClasses, textColorStyles } = useTextColor(computed(() => {
    if (props.error || props.disabled)
      return void 0;
    return model.value ? props.color : props.baseColor;
  }));
  const { backgroundColorClasses, backgroundColorStyles } = useBackgroundColor(computed(() => {
    return model.value && !props.error && !props.disabled ? props.color : props.baseColor;
  }));
  const icon = computed(() => model.value ? props.trueIcon : props.falseIcon);
  return {
    group,
    densityClasses,
    trueValue,
    falseValue,
    model,
    textColorClasses,
    textColorStyles,
    backgroundColorClasses,
    backgroundColorStyles,
    icon
  };
}
const VSelectionControl = genericComponent()({
  name: "VSelectionControl",
  directives: { Ripple },
  inheritAttrs: false,
  props: makeVSelectionControlProps(),
  emits: {
    "update:modelValue": (value) => true
  },
  setup(props, { attrs, slots }) {
    const {
      group,
      densityClasses,
      icon,
      model,
      textColorClasses,
      textColorStyles,
      backgroundColorClasses,
      backgroundColorStyles,
      trueValue
    } = useSelectionControl(props);
    const uid = getUid();
    const isFocused = shallowRef(false);
    const isFocusVisible = shallowRef(false);
    const input = ref();
    const id = computed(() => props.id || `input-${uid}`);
    const isInteractive = computed(() => !props.disabled && !props.readonly);
    group == null ? void 0 : group.onForceUpdate(() => {
      if (input.value) {
        input.value.checked = model.value;
      }
    });
    function onFocus(e) {
      if (!isInteractive.value)
        return;
      isFocused.value = true;
      if (matchesSelector(e.target, ":focus-visible") !== false) {
        isFocusVisible.value = true;
      }
    }
    function onBlur() {
      isFocused.value = false;
      isFocusVisible.value = false;
    }
    function onClickLabel(e) {
      e.stopPropagation();
    }
    function onInput(e) {
      if (!isInteractive.value) {
        if (input.value) {
          input.value.checked = model.value;
        }
        return;
      }
      if (props.readonly && group) {
        nextTick(() => group.forceUpdate());
      }
      model.value = e.target.checked;
    }
    useRender(() => {
      var _a, _b;
      const label = slots.label ? slots.label({
        label: props.label,
        props: { for: id.value }
      }) : props.label;
      const [rootAttrs, inputAttrs] = filterInputAttrs(attrs);
      const inputNode = /* @__PURE__ */ React.createElement(
        "input",
        {
          ref: input,
          checked: model.value,
          disabled: !!props.disabled,
          id: id.value,
          onBlur,
          onFocus,
          onInput,
          "aria-disabled": !!props.disabled,
          "aria-label": props.label,
          type: props.type,
          value: trueValue.value,
          name: props.name,
          "aria-checked": props.type === "checkbox" ? model.value : void 0,
          ...inputAttrs
        }
      );
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          class: [
            "v-selection-control",
            {
              "v-selection-control--dirty": model.value,
              "v-selection-control--disabled": props.disabled,
              "v-selection-control--error": props.error,
              "v-selection-control--focused": isFocused.value,
              "v-selection-control--focus-visible": isFocusVisible.value,
              "v-selection-control--inline": props.inline
            },
            densityClasses.value,
            props.class
          ],
          ...rootAttrs,
          style: props.style
        },
        /* @__PURE__ */ React.createElement(
          "div",
          {
            class: [
              "v-selection-control__wrapper",
              textColorClasses.value
            ],
            style: textColorStyles.value
          },
          (_a = slots.default) == null ? void 0 : _a.call(slots, {
            backgroundColorClasses,
            backgroundColorStyles
          }),
          /* @__PURE__ */ React.createElement(
            "div",
            {
              class: [
                "v-selection-control__input"
              ],
              "v-ripple": props.ripple && [
                !props.disabled && !props.readonly,
                null,
                ["center", "circle"]
              ]
            },
            ((_b = slots.input) == null ? void 0 : _b.call(slots, {
              model,
              textColorClasses,
              textColorStyles,
              backgroundColorClasses,
              backgroundColorStyles,
              inputNode,
              icon: icon.value,
              props: {
                onFocus,
                onBlur,
                id: id.value
              }
            })) ?? /* @__PURE__ */ React.createElement(React.Fragment, null, icon.value && /* @__PURE__ */ React.createElement(VIcon, { key: "icon", icon: icon.value }), inputNode)
          )
        ),
        label && /* @__PURE__ */ React.createElement(VLabel, { for: id.value, onClick: onClickLabel }, label)
      );
    });
    return {
      isFocused,
      input
    };
  }
});
const makeVCheckboxBtnProps = propsFactory({
  indeterminate: Boolean,
  indeterminateIcon: {
    type: IconValue,
    default: "$checkboxIndeterminate"
  },
  ...makeVSelectionControlProps({
    falseIcon: "$checkboxOff",
    trueIcon: "$checkboxOn"
  })
}, "VCheckboxBtn");
const VCheckboxBtn = genericComponent()({
  name: "VCheckboxBtn",
  props: makeVCheckboxBtnProps(),
  emits: {
    "update:modelValue": (value) => true,
    "update:indeterminate": (value) => true
  },
  setup(props, { slots }) {
    const indeterminate = useProxiedModel(props, "indeterminate");
    const model = useProxiedModel(props, "modelValue");
    function onChange(v) {
      if (indeterminate.value) {
        indeterminate.value = false;
      }
    }
    const falseIcon = computed(() => {
      return indeterminate.value ? props.indeterminateIcon : props.falseIcon;
    });
    const trueIcon = computed(() => {
      return indeterminate.value ? props.indeterminateIcon : props.trueIcon;
    });
    useRender(() => {
      const controlProps = omit(VSelectionControl.filterProps(props), ["modelValue"]);
      return /* @__PURE__ */ React.createElement(
        VSelectionControl,
        {
          ...controlProps,
          "v-model": model.value,
          class: [
            "v-checkbox-btn",
            props.class
          ],
          style: props.style,
          type: "checkbox",
          "onUpdate:modelValue": onChange,
          falseIcon: falseIcon.value,
          trueIcon: trueIcon.value,
          "aria-checked": indeterminate.value ? "mixed" : void 0,
          "v-slots": slots
        }
      );
    });
    return {};
  }
});
const makeVCheckboxProps = propsFactory({
  ...makeVInputProps(),
  ...omit(makeVCheckboxBtnProps(), ["inline"])
}, "VCheckbox");
genericComponent()({
  name: "VCheckbox",
  inheritAttrs: false,
  props: makeVCheckboxProps(),
  emits: {
    "update:modelValue": (value) => true,
    "update:focused": (focused) => true
  },
  setup(props, { attrs, slots }) {
    const model = useProxiedModel(props, "modelValue");
    const { isFocused, focus, blur } = useFocus(props);
    const uid = getUid();
    const id = computed(() => props.id || `checkbox-${uid}`);
    useRender(() => {
      const [rootAttrs, controlAttrs] = filterInputAttrs(attrs);
      const inputProps = VInput.filterProps(props);
      const checkboxProps = VCheckboxBtn.filterProps(props);
      return /* @__PURE__ */ React.createElement(
        VInput,
        {
          class: [
            "v-checkbox",
            props.class
          ],
          ...rootAttrs,
          ...inputProps,
          "v-model": model.value,
          id: id.value,
          focused: isFocused.value,
          style: props.style
        },
        {
          ...slots,
          default: ({
            id: id2,
            messagesId,
            isDisabled,
            isReadonly,
            isValid
          }) => /* @__PURE__ */ React.createElement(
            VCheckboxBtn,
            {
              ...checkboxProps,
              id: id2.value,
              "aria-describedby": messagesId.value,
              disabled: isDisabled.value,
              readonly: isReadonly.value,
              ...controlAttrs,
              error: isValid.value === false,
              "v-model": model.value,
              onFocus: focus,
              onBlur: blur,
              "v-slots": slots
            }
          )
        }
      );
    });
    return {};
  }
});
const _VChip = "";
const _VChipGroup = "";
const _VSlideGroup = "";
const DisplaySymbol = Symbol.for("vuetify:display");
const makeDisplayProps = propsFactory({
  mobile: {
    type: Boolean,
    default: false
  },
  mobileBreakpoint: [Number, String]
}, "display");
function useDisplay(props = {}, name = getCurrentInstanceName()) {
  const display = inject(DisplaySymbol);
  if (!display)
    throw new Error("Could not find Vuetify display injection");
  const mobile = computed(() => {
    if (props.mobile != null)
      return props.mobile;
    if (!props.mobileBreakpoint)
      return display.mobile.value;
    const breakpointValue = typeof props.mobileBreakpoint === "number" ? props.mobileBreakpoint : display.thresholds.value[props.mobileBreakpoint];
    return display.width.value < breakpointValue;
  });
  const displayClasses = computed(() => {
    if (!name)
      return {};
    return { [`${name}--mobile`]: mobile.value };
  });
  return { ...display, displayClasses, mobile };
}
const GoToSymbol = Symbol.for("vuetify:goto");
function genDefaults() {
  return {
    container: void 0,
    duration: 300,
    layout: false,
    offset: 0,
    easing: "easeInOutCubic",
    patterns: {
      linear: (t) => t,
      easeInQuad: (t) => t ** 2,
      easeOutQuad: (t) => t * (2 - t),
      easeInOutQuad: (t) => t < 0.5 ? 2 * t ** 2 : -1 + (4 - 2 * t) * t,
      easeInCubic: (t) => t ** 3,
      easeOutCubic: (t) => --t ** 3 + 1,
      easeInOutCubic: (t) => t < 0.5 ? 4 * t ** 3 : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
      easeInQuart: (t) => t ** 4,
      easeOutQuart: (t) => 1 - --t ** 4,
      easeInOutQuart: (t) => t < 0.5 ? 8 * t ** 4 : 1 - 8 * --t ** 4,
      easeInQuint: (t) => t ** 5,
      easeOutQuint: (t) => 1 + --t ** 5,
      easeInOutQuint: (t) => t < 0.5 ? 16 * t ** 5 : 1 + 16 * --t ** 5
    }
  };
}
function getContainer(el) {
  return getTarget$1(el) ?? (document.scrollingElement || document.body);
}
function getTarget$1(el) {
  return typeof el === "string" ? document.querySelector(el) : refElement(el);
}
function getOffset$1(target, horizontal, rtl) {
  if (typeof target === "number")
    return horizontal && rtl ? -target : target;
  let el = getTarget$1(target);
  let totalOffset = 0;
  while (el) {
    totalOffset += horizontal ? el.offsetLeft : el.offsetTop;
    el = el.offsetParent;
  }
  return totalOffset;
}
async function scrollTo(_target, _options, horizontal, goTo) {
  const property = horizontal ? "scrollLeft" : "scrollTop";
  const options = mergeDeep((goTo == null ? void 0 : goTo.options) ?? genDefaults(), _options);
  const rtl = goTo == null ? void 0 : goTo.rtl.value;
  const target = (typeof _target === "number" ? _target : getTarget$1(_target)) ?? 0;
  const container = options.container === "parent" && target instanceof HTMLElement ? target.parentElement : getContainer(options.container);
  const ease = typeof options.easing === "function" ? options.easing : options.patterns[options.easing];
  if (!ease)
    throw new TypeError(`Easing function "${options.easing}" not found.`);
  let targetLocation;
  if (typeof target === "number") {
    targetLocation = getOffset$1(target, horizontal, rtl);
  } else {
    targetLocation = getOffset$1(target, horizontal, rtl) - getOffset$1(container, horizontal, rtl);
    if (options.layout) {
      const styles = window.getComputedStyle(target);
      const layoutOffset = styles.getPropertyValue("--v-layout-top");
      if (layoutOffset)
        targetLocation -= parseInt(layoutOffset, 10);
    }
  }
  targetLocation += options.offset;
  targetLocation = clampTarget(container, targetLocation, !!rtl, !!horizontal);
  const startLocation = container[property] ?? 0;
  if (targetLocation === startLocation)
    return Promise.resolve(targetLocation);
  const startTime = performance.now();
  return new Promise((resolve) => requestAnimationFrame(function step(currentTime) {
    const timeElapsed = currentTime - startTime;
    const progress = timeElapsed / options.duration;
    const location = Math.floor(
      startLocation + (targetLocation - startLocation) * ease(clamp(progress, 0, 1))
    );
    container[property] = location;
    if (progress >= 1 && Math.abs(location - container[property]) < 10) {
      return resolve(targetLocation);
    } else if (progress > 2) {
      consoleWarn("Scroll target is not reachable");
      return resolve(container[property]);
    }
    requestAnimationFrame(step);
  }));
}
function useGoTo(_options = {}) {
  const goToInstance = inject(GoToSymbol);
  const { isRtl } = useRtl();
  if (!goToInstance)
    throw new Error("[Vuetify] Could not find injected goto instance");
  const goTo = {
    ...goToInstance,
    // can be set via VLocaleProvider
    rtl: computed(() => goToInstance.rtl.value || isRtl.value)
  };
  async function go(target, options) {
    return scrollTo(target, mergeDeep(_options, options), false, goTo);
  }
  go.horizontal = async (target, options) => {
    return scrollTo(target, mergeDeep(_options, options), true, goTo);
  };
  return go;
}
function clampTarget(container, value, rtl, horizontal) {
  const { scrollWidth, scrollHeight } = container;
  const [containerWidth, containerHeight] = container === document.scrollingElement ? [window.innerWidth, window.innerHeight] : [container.offsetWidth, container.offsetHeight];
  let min;
  let max;
  if (horizontal) {
    if (rtl) {
      min = -(scrollWidth - containerWidth);
      max = 0;
    } else {
      min = 0;
      max = scrollWidth - containerWidth;
    }
  } else {
    min = 0;
    max = scrollHeight + -containerHeight;
  }
  return Math.max(Math.min(value, max), min);
}
const makeGroupProps = propsFactory({
  modelValue: {
    type: null,
    default: void 0
  },
  multiple: Boolean,
  mandatory: [Boolean, String],
  max: Number,
  selectedClass: String,
  disabled: Boolean
}, "group");
const makeGroupItemProps = propsFactory({
  value: null,
  disabled: Boolean,
  selectedClass: String
}, "group-item");
function useGroupItem(props, injectKey, required = true) {
  const vm = getCurrentInstance("useGroupItem");
  if (!vm) {
    throw new Error(
      "[Vuetify] useGroupItem composable must be used inside a component setup function"
    );
  }
  const id = getUid();
  provide(Symbol.for(`${injectKey.description}:id`), id);
  const group = inject(injectKey, null);
  if (!group) {
    if (!required)
      return group;
    throw new Error(`[Vuetify] Could not find useGroup injection with symbol ${injectKey.description}`);
  }
  const value = toRef(props, "value");
  const disabled = computed(() => !!(group.disabled.value || props.disabled));
  group.register({
    id,
    value,
    disabled
  }, vm);
  onBeforeUnmount(() => {
    group.unregister(id);
  });
  const isSelected = computed(() => {
    return group.isSelected(id);
  });
  const isFirst = computed(() => {
    return group.items.value[0].id === id;
  });
  const isLast = computed(() => {
    return group.items.value[group.items.value.length - 1].id === id;
  });
  const selectedClass = computed(() => isSelected.value && [group.selectedClass.value, props.selectedClass]);
  watch(isSelected, (value2) => {
    vm.emit("group:selected", { value: value2 });
  }, { flush: "sync" });
  return {
    id,
    isSelected,
    isFirst,
    isLast,
    toggle: () => group.select(id, !isSelected.value),
    select: (value2) => group.select(id, value2),
    selectedClass,
    value,
    disabled,
    group
  };
}
function useGroup(props, injectKey) {
  let isUnmounted = false;
  const items = reactive([]);
  const selected = useProxiedModel(
    props,
    "modelValue",
    [],
    (v) => {
      if (v == null)
        return [];
      return getIds(items, wrapInArray(v));
    },
    (v) => {
      const arr = getValues(items, v);
      return props.multiple ? arr : arr[0];
    }
  );
  const groupVm = getCurrentInstance("useGroup");
  function register(item, vm) {
    const unwrapped = item;
    const key = Symbol.for(`${injectKey.description}:id`);
    const children = findChildrenWithProvide(key, groupVm == null ? void 0 : groupVm.vnode);
    const index = children.indexOf(vm);
    if (unref(unwrapped.value) == null) {
      unwrapped.value = index;
      unwrapped.useIndexAsValue = true;
    }
    if (index > -1) {
      items.splice(index, 0, unwrapped);
    } else {
      items.push(unwrapped);
    }
  }
  function unregister(id) {
    if (isUnmounted)
      return;
    forceMandatoryValue();
    const index = items.findIndex((item) => item.id === id);
    items.splice(index, 1);
  }
  function forceMandatoryValue() {
    const item = items.find((item2) => !item2.disabled);
    if (item && props.mandatory === "force" && !selected.value.length) {
      selected.value = [item.id];
    }
  }
  onMounted(() => {
    forceMandatoryValue();
  });
  onBeforeUnmount(() => {
    isUnmounted = true;
  });
  onUpdated(() => {
    for (let i = 0; i < items.length; i++) {
      if (items[i].useIndexAsValue) {
        items[i].value = i;
      }
    }
  });
  function select(id, value) {
    const item = items.find((item2) => item2.id === id);
    if (value && (item == null ? void 0 : item.disabled))
      return;
    if (props.multiple) {
      const internalValue = selected.value.slice();
      const index = internalValue.findIndex((v) => v === id);
      const isSelected = ~index;
      value = value ?? !isSelected;
      if (isSelected && props.mandatory && internalValue.length <= 1)
        return;
      if (!isSelected && props.max != null && internalValue.length + 1 > props.max)
        return;
      if (index < 0 && value)
        internalValue.push(id);
      else if (index >= 0 && !value)
        internalValue.splice(index, 1);
      selected.value = internalValue;
    } else {
      const isSelected = selected.value.includes(id);
      if (props.mandatory && isSelected)
        return;
      selected.value = value ?? !isSelected ? [id] : [];
    }
  }
  function step(offset) {
    if (props.multiple)
      consoleWarn('This method is not supported when using "multiple" prop');
    if (!selected.value.length) {
      const item = items.find((item2) => !item2.disabled);
      item && (selected.value = [item.id]);
    } else {
      const currentId = selected.value[0];
      const currentIndex = items.findIndex((i) => i.id === currentId);
      let newIndex = (currentIndex + offset) % items.length;
      let newItem = items[newIndex];
      while (newItem.disabled && newIndex !== currentIndex) {
        newIndex = (newIndex + offset) % items.length;
        newItem = items[newIndex];
      }
      if (newItem.disabled)
        return;
      selected.value = [items[newIndex].id];
    }
  }
  const state = {
    register,
    unregister,
    selected,
    select,
    disabled: toRef(props, "disabled"),
    prev: () => step(items.length - 1),
    next: () => step(1),
    isSelected: (id) => selected.value.includes(id),
    selectedClass: computed(() => props.selectedClass),
    items: computed(() => items),
    getItemIndex: (value) => getItemIndex(items, value)
  };
  provide(injectKey, state);
  return state;
}
function getItemIndex(items, value) {
  const ids = getIds(items, [value]);
  if (!ids.length)
    return -1;
  return items.findIndex((item) => item.id === ids[0]);
}
function getIds(items, modelValue) {
  const ids = [];
  modelValue.forEach((value) => {
    const item = items.find((item2) => deepEqual(value, item2.value));
    const itemByIndex = items[value];
    if ((item == null ? void 0 : item.value) != null) {
      ids.push(item.id);
    } else if (itemByIndex != null) {
      ids.push(itemByIndex.id);
    }
  });
  return ids;
}
function getValues(items, ids) {
  const values = [];
  ids.forEach((id) => {
    const itemIndex = items.findIndex((item) => item.id === id);
    if (~itemIndex) {
      const item = items[itemIndex];
      values.push(item.value != null ? item.value : itemIndex);
    }
  });
  return values;
}
function useResizeObserver(callback, box = "content") {
  const resizeRef = templateRef();
  const contentRect = ref();
  if (IN_BROWSER) {
    const observer = new ResizeObserver((entries) => {
      callback == null ? void 0 : callback(entries, observer);
      if (!entries.length)
        return;
      if (box === "content") {
        contentRect.value = entries[0].contentRect;
      } else {
        contentRect.value = entries[0].target.getBoundingClientRect();
      }
    });
    onBeforeUnmount(() => {
      observer.disconnect();
    });
    watch(() => resizeRef.el, (newValue, oldValue) => {
      if (oldValue) {
        observer.unobserve(oldValue);
        contentRect.value = void 0;
      }
      if (newValue)
        observer.observe(newValue);
    }, {
      flush: "post"
    });
  }
  return {
    resizeRef,
    contentRect: readonly(contentRect)
  };
}
function calculateUpdatedTarget({
  selectedElement,
  containerElement,
  isRtl,
  isHorizontal
}) {
  const containerSize = getOffsetSize(isHorizontal, containerElement);
  const scrollPosition = getScrollPosition(isHorizontal, isRtl, containerElement);
  const childrenSize = getOffsetSize(isHorizontal, selectedElement);
  const childrenStartPosition = getOffsetPosition(isHorizontal, selectedElement);
  const additionalOffset = childrenSize * 0.4;
  if (scrollPosition > childrenStartPosition) {
    return childrenStartPosition - additionalOffset;
  } else if (scrollPosition + containerSize < childrenStartPosition + childrenSize) {
    return childrenStartPosition - containerSize + childrenSize + additionalOffset;
  }
  return scrollPosition;
}
function calculateCenteredTarget({
  selectedElement,
  containerElement,
  isHorizontal
}) {
  const containerOffsetSize = getOffsetSize(isHorizontal, containerElement);
  const childrenOffsetPosition = getOffsetPosition(isHorizontal, selectedElement);
  const childrenOffsetSize = getOffsetSize(isHorizontal, selectedElement);
  return childrenOffsetPosition - containerOffsetSize / 2 + childrenOffsetSize / 2;
}
function getScrollSize(isHorizontal, element) {
  const key = isHorizontal ? "scrollWidth" : "scrollHeight";
  return (element == null ? void 0 : element[key]) || 0;
}
function getClientSize(isHorizontal, element) {
  const key = isHorizontal ? "clientWidth" : "clientHeight";
  return (element == null ? void 0 : element[key]) || 0;
}
function getScrollPosition(isHorizontal, rtl, element) {
  if (!element) {
    return 0;
  }
  const {
    scrollLeft,
    offsetWidth,
    scrollWidth
  } = element;
  if (isHorizontal) {
    return rtl ? scrollWidth - offsetWidth + scrollLeft : scrollLeft;
  }
  return element.scrollTop;
}
function getOffsetSize(isHorizontal, element) {
  const key = isHorizontal ? "offsetWidth" : "offsetHeight";
  return (element == null ? void 0 : element[key]) || 0;
}
function getOffsetPosition(isHorizontal, element) {
  const key = isHorizontal ? "offsetLeft" : "offsetTop";
  return (element == null ? void 0 : element[key]) || 0;
}
const VSlideGroupSymbol = Symbol.for("vuetify:v-slide-group");
const makeVSlideGroupProps = propsFactory({
  centerActive: Boolean,
  direction: {
    type: String,
    default: "horizontal"
  },
  symbol: {
    type: null,
    default: VSlideGroupSymbol
  },
  nextIcon: {
    type: IconValue,
    default: "$next"
  },
  prevIcon: {
    type: IconValue,
    default: "$prev"
  },
  showArrows: {
    type: [Boolean, String],
    validator: (v) => typeof v === "boolean" || [
      "always",
      "desktop",
      "mobile"
    ].includes(v)
  },
  ...makeComponentProps(),
  ...makeDisplayProps({ mobile: null }),
  ...makeTagProps(),
  ...makeGroupProps({
    selectedClass: "v-slide-group-item--active"
  })
}, "VSlideGroup");
const VSlideGroup = genericComponent()({
  name: "VSlideGroup",
  props: makeVSlideGroupProps(),
  emits: {
    "update:modelValue": (value) => true
  },
  setup(props, { slots }) {
    const { isRtl } = useRtl();
    const { displayClasses, mobile } = useDisplay(props);
    const group = useGroup(props, props.symbol);
    const isOverflowing = shallowRef(false);
    const scrollOffset = shallowRef(0);
    const containerSize = shallowRef(0);
    const contentSize = shallowRef(0);
    const isHorizontal = computed(() => props.direction === "horizontal");
    const { resizeRef: containerRef, contentRect: containerRect } = useResizeObserver();
    const { resizeRef: contentRef, contentRect } = useResizeObserver();
    const goTo = useGoTo();
    const goToOptions = computed(() => {
      return {
        container: containerRef.el,
        duration: 200,
        easing: "easeOutQuart"
      };
    });
    const firstSelectedIndex = computed(() => {
      if (!group.selected.value.length)
        return -1;
      return group.items.value.findIndex((item) => item.id === group.selected.value[0]);
    });
    const lastSelectedIndex = computed(() => {
      if (!group.selected.value.length)
        return -1;
      return group.items.value.findIndex((item) => item.id === group.selected.value[group.selected.value.length - 1]);
    });
    if (IN_BROWSER) {
      let frame = -1;
      watch(() => [group.selected.value, containerRect.value, contentRect.value, isHorizontal.value], () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          if (containerRect.value && contentRect.value) {
            const sizeProperty = isHorizontal.value ? "width" : "height";
            containerSize.value = containerRect.value[sizeProperty];
            contentSize.value = contentRect.value[sizeProperty];
            isOverflowing.value = containerSize.value + 1 < contentSize.value;
          }
          if (firstSelectedIndex.value >= 0 && contentRef.el) {
            const selectedElement = contentRef.el.children[lastSelectedIndex.value];
            scrollToChildren(selectedElement, props.centerActive);
          }
        });
      });
    }
    const isFocused = shallowRef(false);
    function scrollToChildren(children, center) {
      let target = 0;
      if (center) {
        target = calculateCenteredTarget({
          containerElement: containerRef.el,
          isHorizontal: isHorizontal.value,
          selectedElement: children
        });
      } else {
        target = calculateUpdatedTarget({
          containerElement: containerRef.el,
          isHorizontal: isHorizontal.value,
          isRtl: isRtl.value,
          selectedElement: children
        });
      }
      scrollToPosition(target);
    }
    function scrollToPosition(newPosition) {
      if (!IN_BROWSER || !containerRef.el)
        return;
      const offsetSize = getOffsetSize(isHorizontal.value, containerRef.el);
      const scrollPosition = getScrollPosition(isHorizontal.value, isRtl.value, containerRef.el);
      const scrollSize = getScrollSize(isHorizontal.value, containerRef.el);
      if (scrollSize <= offsetSize || // Prevent scrolling by only a couple of pixels, which doesn't look smooth
      Math.abs(newPosition - scrollPosition) < 16)
        return;
      if (isHorizontal.value && isRtl.value && containerRef.el) {
        const { scrollWidth, offsetWidth: containerWidth } = containerRef.el;
        newPosition = scrollWidth - containerWidth - newPosition;
      }
      if (isHorizontal.value) {
        goTo.horizontal(newPosition, goToOptions.value);
      } else {
        goTo(newPosition, goToOptions.value);
      }
    }
    function onScroll(e) {
      const { scrollTop, scrollLeft } = e.target;
      scrollOffset.value = isHorizontal.value ? scrollLeft : scrollTop;
    }
    function onFocusin(e) {
      isFocused.value = true;
      if (!isOverflowing.value || !contentRef.el)
        return;
      for (const el of e.composedPath()) {
        for (const item of contentRef.el.children) {
          if (item === el) {
            scrollToChildren(item);
            return;
          }
        }
      }
    }
    function onFocusout(e) {
      isFocused.value = false;
    }
    let ignoreFocusEvent = false;
    function onFocus(e) {
      var _a;
      if (!ignoreFocusEvent && !isFocused.value && !(e.relatedTarget && ((_a = contentRef.el) == null ? void 0 : _a.contains(e.relatedTarget))))
        focus();
      ignoreFocusEvent = false;
    }
    function onFocusAffixes() {
      ignoreFocusEvent = true;
    }
    function onKeydown(e) {
      if (!contentRef.el)
        return;
      function toFocus(location) {
        e.preventDefault();
        focus(location);
      }
      if (isHorizontal.value) {
        if (e.key === "ArrowRight") {
          toFocus(isRtl.value ? "prev" : "next");
        } else if (e.key === "ArrowLeft") {
          toFocus(isRtl.value ? "next" : "prev");
        }
      } else {
        if (e.key === "ArrowDown") {
          toFocus("next");
        } else if (e.key === "ArrowUp") {
          toFocus("prev");
        }
      }
      if (e.key === "Home") {
        toFocus("first");
      } else if (e.key === "End") {
        toFocus("last");
      }
    }
    function focus(location) {
      var _a, _b;
      if (!contentRef.el)
        return;
      let el;
      if (!location) {
        const focusable = focusableChildren(contentRef.el);
        el = focusable[0];
      } else if (location === "next") {
        el = (_a = contentRef.el.querySelector(":focus")) == null ? void 0 : _a.nextElementSibling;
        if (!el)
          return focus("first");
      } else if (location === "prev") {
        el = (_b = contentRef.el.querySelector(":focus")) == null ? void 0 : _b.previousElementSibling;
        if (!el)
          return focus("last");
      } else if (location === "first") {
        el = contentRef.el.firstElementChild;
      } else if (location === "last") {
        el = contentRef.el.lastElementChild;
      }
      if (el) {
        el.focus({ preventScroll: true });
      }
    }
    function scrollTo2(location) {
      const direction = isHorizontal.value && isRtl.value ? -1 : 1;
      const offsetStep = (location === "prev" ? -direction : direction) * containerSize.value;
      let newPosition = scrollOffset.value + offsetStep;
      if (isHorizontal.value && isRtl.value && containerRef.el) {
        const { scrollWidth, offsetWidth: containerWidth } = containerRef.el;
        newPosition += scrollWidth - containerWidth;
      }
      scrollToPosition(newPosition);
    }
    const slotProps = computed(() => ({
      next: group.next,
      prev: group.prev,
      select: group.select,
      isSelected: group.isSelected
    }));
    const hasAffixes = computed(() => {
      switch (props.showArrows) {
        case "always":
          return true;
        case "desktop":
          return !mobile.value;
        case true:
          return isOverflowing.value || Math.abs(scrollOffset.value) > 0;
        case "mobile":
          return mobile.value || (isOverflowing.value || Math.abs(scrollOffset.value) > 0);
        default:
          return !mobile.value && (isOverflowing.value || Math.abs(scrollOffset.value) > 0);
      }
    });
    const hasPrev = computed(() => {
      return Math.abs(scrollOffset.value) > 1;
    });
    const hasNext = computed(() => {
      if (!containerRef.value)
        return false;
      const scrollSize = getScrollSize(isHorizontal.value, containerRef.el);
      const clientSize = getClientSize(isHorizontal.value, containerRef.el);
      const scrollSizeMax = scrollSize - clientSize;
      return scrollSizeMax - Math.abs(scrollOffset.value) > 1;
    });
    useRender(() => {
      var _a, _b, _c;
      return /* @__PURE__ */ React.createElement(
        props.tag,
        {
          class: [
            "v-slide-group",
            {
              "v-slide-group--vertical": !isHorizontal.value,
              "v-slide-group--has-affixes": hasAffixes.value,
              "v-slide-group--is-overflowing": isOverflowing.value
            },
            displayClasses.value,
            props.class
          ],
          style: props.style,
          tabindex: isFocused.value || group.selected.value.length ? -1 : 0,
          onFocus
        },
        hasAffixes.value && /* @__PURE__ */ React.createElement(
          "div",
          {
            key: "prev",
            class: [
              "v-slide-group__prev",
              { "v-slide-group__prev--disabled": !hasPrev.value }
            ],
            onMousedown: onFocusAffixes,
            onClick: () => hasPrev.value && scrollTo2("prev")
          },
          ((_a = slots.prev) == null ? void 0 : _a.call(slots, slotProps.value)) ?? /* @__PURE__ */ React.createElement(VFadeTransition, null, /* @__PURE__ */ React.createElement(VIcon, { icon: isRtl.value ? props.nextIcon : props.prevIcon }))
        ),
        /* @__PURE__ */ React.createElement(
          "div",
          {
            key: "container",
            ref: containerRef,
            class: "v-slide-group__container",
            onScroll
          },
          /* @__PURE__ */ React.createElement(
            "div",
            {
              ref: contentRef,
              class: "v-slide-group__content",
              onFocusin,
              onFocusout,
              onKeydown
            },
            (_b = slots.default) == null ? void 0 : _b.call(slots, slotProps.value)
          )
        ),
        hasAffixes.value && /* @__PURE__ */ React.createElement(
          "div",
          {
            key: "next",
            class: [
              "v-slide-group__next",
              { "v-slide-group__next--disabled": !hasNext.value }
            ],
            onMousedown: onFocusAffixes,
            onClick: () => hasNext.value && scrollTo2("next")
          },
          ((_c = slots.next) == null ? void 0 : _c.call(slots, slotProps.value)) ?? /* @__PURE__ */ React.createElement(VFadeTransition, null, /* @__PURE__ */ React.createElement(VIcon, { icon: isRtl.value ? props.prevIcon : props.nextIcon }))
        )
      );
    });
    return {
      selected: group.selected,
      scrollTo: scrollTo2,
      scrollOffset,
      focus
    };
  }
});
const VChipGroupSymbol = Symbol.for("vuetify:v-chip-group");
const makeVChipGroupProps = propsFactory({
  column: Boolean,
  filter: Boolean,
  valueComparator: {
    type: Function,
    default: deepEqual
  },
  ...makeVSlideGroupProps(),
  ...makeComponentProps(),
  ...makeGroupProps({ selectedClass: "v-chip--selected" }),
  ...makeTagProps(),
  ...makeThemeProps(),
  ...makeVariantProps({ variant: "tonal" })
}, "VChipGroup");
genericComponent()({
  name: "VChipGroup",
  props: makeVChipGroupProps(),
  emits: {
    "update:modelValue": (value) => true
  },
  setup(props, { slots }) {
    const { themeClasses } = provideTheme(props);
    const { isSelected, select, next, prev, selected } = useGroup(props, VChipGroupSymbol);
    provideDefaults({
      VChip: {
        color: toRef(props, "color"),
        disabled: toRef(props, "disabled"),
        filter: toRef(props, "filter"),
        variant: toRef(props, "variant")
      }
    });
    useRender(() => {
      var _a;
      const slideGroupProps = VSlideGroup.filterProps(props);
      return /* @__PURE__ */ React.createElement(
        VSlideGroup,
        {
          ...slideGroupProps,
          class: [
            "v-chip-group",
            {
              "v-chip-group--column": props.column
            },
            themeClasses.value,
            props.class
          ],
          style: props.style
        },
        (_a = slots.default) == null ? void 0 : _a.call(slots, {
          isSelected,
          select,
          next,
          prev,
          selected: selected.value
        })
      );
    });
    return {};
  }
});
const makeVChipProps = propsFactory({
  activeClass: String,
  appendAvatar: String,
  appendIcon: IconValue,
  closable: Boolean,
  closeIcon: {
    type: IconValue,
    default: "$delete"
  },
  closeLabel: {
    type: String,
    default: "$vuetify.close"
  },
  draggable: Boolean,
  filter: Boolean,
  filterIcon: {
    type: String,
    default: "$complete"
  },
  label: Boolean,
  link: {
    type: Boolean,
    default: void 0
  },
  pill: Boolean,
  prependAvatar: String,
  prependIcon: IconValue,
  ripple: {
    type: [Boolean, Object],
    default: true
  },
  text: String,
  modelValue: {
    type: Boolean,
    default: true
  },
  onClick: EventProp(),
  onClickOnce: EventProp(),
  ...makeBorderProps(),
  ...makeComponentProps(),
  ...makeDensityProps(),
  ...makeElevationProps(),
  ...makeGroupItemProps(),
  ...makeRoundedProps(),
  ...makeRouterProps(),
  ...makeSizeProps(),
  ...makeTagProps({ tag: "span" }),
  ...makeThemeProps(),
  ...makeVariantProps({ variant: "tonal" })
}, "VChip");
const VChip = genericComponent()({
  name: "VChip",
  directives: { Ripple },
  props: makeVChipProps(),
  emits: {
    "click:close": (e) => true,
    "update:modelValue": (value) => true,
    "group:selected": (val) => true,
    click: (e) => true
  },
  setup(props, { attrs, emit, slots }) {
    const { t } = useLocale();
    const { borderClasses } = useBorder(props);
    const { colorClasses, colorStyles, variantClasses } = useVariant(props);
    const { densityClasses } = useDensity(props);
    const { elevationClasses } = useElevation(props);
    const { roundedClasses } = useRounded(props);
    const { sizeClasses } = useSize(props);
    const { themeClasses } = provideTheme(props);
    const isActive = useProxiedModel(props, "modelValue");
    const group = useGroupItem(props, VChipGroupSymbol, false);
    const link = useLink(props, attrs);
    const isLink = computed(() => props.link !== false && link.isLink.value);
    const isClickable = computed(
      () => !props.disabled && props.link !== false && (!!group || props.link || link.isClickable.value)
    );
    const closeProps = computed(() => ({
      "aria-label": t(props.closeLabel),
      onClick(e) {
        e.preventDefault();
        e.stopPropagation();
        isActive.value = false;
        emit("click:close", e);
      }
    }));
    function onClick(e) {
      var _a;
      emit("click", e);
      if (!isClickable.value)
        return;
      (_a = link.navigate) == null ? void 0 : _a.call(link, e);
      group == null ? void 0 : group.toggle();
    }
    function onKeyDown(e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick(e);
      }
    }
    return () => {
      var _a;
      const Tag = link.isLink.value ? "a" : props.tag;
      const hasAppendMedia = !!(props.appendIcon || props.appendAvatar);
      const hasAppend = !!(hasAppendMedia || slots.append);
      const hasClose = !!(slots.close || props.closable);
      const hasFilter = !!(slots.filter || props.filter) && group;
      const hasPrependMedia = !!(props.prependIcon || props.prependAvatar);
      const hasPrepend = !!(hasPrependMedia || slots.prepend);
      const hasColor = !group || group.isSelected.value;
      return isActive.value && /* @__PURE__ */ React.createElement(
        Tag,
        {
          class: [
            "v-chip",
            {
              "v-chip--disabled": props.disabled,
              "v-chip--label": props.label,
              "v-chip--link": isClickable.value,
              "v-chip--filter": hasFilter,
              "v-chip--pill": props.pill
            },
            themeClasses.value,
            borderClasses.value,
            hasColor ? colorClasses.value : void 0,
            densityClasses.value,
            elevationClasses.value,
            roundedClasses.value,
            sizeClasses.value,
            variantClasses.value,
            group == null ? void 0 : group.selectedClass.value,
            props.class
          ],
          style: [
            hasColor ? colorStyles.value : void 0,
            props.style
          ],
          disabled: props.disabled || void 0,
          draggable: props.draggable,
          href: link.href.value,
          tabindex: isClickable.value ? 0 : void 0,
          onClick,
          onKeydown: isClickable.value && !isLink.value && onKeyDown,
          "v-ripple": [isClickable.value && props.ripple, null]
        },
        genOverlays(isClickable.value, "v-chip"),
        hasFilter && /* @__PURE__ */ React.createElement(VExpandXTransition, { key: "filter" }, /* @__PURE__ */ React.createElement(
          "div",
          {
            class: "v-chip__filter",
            "v-show": group.isSelected.value
          },
          !slots.filter ? /* @__PURE__ */ React.createElement(
            VIcon,
            {
              key: "filter-icon",
              icon: props.filterIcon
            }
          ) : /* @__PURE__ */ React.createElement(
            VDefaultsProvider,
            {
              key: "filter-defaults",
              disabled: !props.filterIcon,
              defaults: {
                VIcon: { icon: props.filterIcon }
              },
              "v-slots:default": slots.filter
            }
          )
        )),
        hasPrepend && /* @__PURE__ */ React.createElement("div", { key: "prepend", class: "v-chip__prepend" }, !slots.prepend ? /* @__PURE__ */ React.createElement(React.Fragment, null, props.prependIcon && /* @__PURE__ */ React.createElement(
          VIcon,
          {
            key: "prepend-icon",
            icon: props.prependIcon,
            start: true
          }
        ), props.prependAvatar && /* @__PURE__ */ React.createElement(
          VAvatar,
          {
            key: "prepend-avatar",
            image: props.prependAvatar,
            start: true
          }
        )) : /* @__PURE__ */ React.createElement(
          VDefaultsProvider,
          {
            key: "prepend-defaults",
            disabled: !hasPrependMedia,
            defaults: {
              VAvatar: {
                image: props.prependAvatar,
                start: true
              },
              VIcon: {
                icon: props.prependIcon,
                start: true
              }
            },
            "v-slots:default": slots.prepend
          }
        )),
        /* @__PURE__ */ React.createElement("div", { class: "v-chip__content", "data-no-activator": "" }, ((_a = slots.default) == null ? void 0 : _a.call(slots, {
          isSelected: group == null ? void 0 : group.isSelected.value,
          selectedClass: group == null ? void 0 : group.selectedClass.value,
          select: group == null ? void 0 : group.select,
          toggle: group == null ? void 0 : group.toggle,
          value: group == null ? void 0 : group.value.value,
          disabled: props.disabled
        })) ?? props.text),
        hasAppend && /* @__PURE__ */ React.createElement("div", { key: "append", class: "v-chip__append" }, !slots.append ? /* @__PURE__ */ React.createElement(React.Fragment, null, props.appendIcon && /* @__PURE__ */ React.createElement(
          VIcon,
          {
            key: "append-icon",
            end: true,
            icon: props.appendIcon
          }
        ), props.appendAvatar && /* @__PURE__ */ React.createElement(
          VAvatar,
          {
            key: "append-avatar",
            end: true,
            image: props.appendAvatar
          }
        )) : /* @__PURE__ */ React.createElement(
          VDefaultsProvider,
          {
            key: "append-defaults",
            disabled: !hasAppendMedia,
            defaults: {
              VAvatar: {
                end: true,
                image: props.appendAvatar
              },
              VIcon: {
                end: true,
                icon: props.appendIcon
              }
            },
            "v-slots:default": slots.append
          }
        )),
        hasClose && /* @__PURE__ */ React.createElement(
          "button",
          {
            key: "close",
            class: "v-chip__close",
            type: "button",
            ...closeProps.value
          },
          !slots.close ? /* @__PURE__ */ React.createElement(
            VIcon,
            {
              key: "close-icon",
              icon: props.closeIcon,
              size: "x-small"
            }
          ) : /* @__PURE__ */ React.createElement(
            VDefaultsProvider,
            {
              key: "close-defaults",
              defaults: {
                VIcon: {
                  icon: props.closeIcon,
                  size: "x-small"
                }
              },
              "v-slots:default": slots.close
            }
          )
        )
      );
    };
  }
});
createSimpleFunctional("v-list-img");
const makeVListItemActionProps = propsFactory({
  start: Boolean,
  end: Boolean,
  ...makeComponentProps(),
  ...makeTagProps()
}, "VListItemAction");
genericComponent()({
  name: "VListItemAction",
  props: makeVListItemActionProps(),
  setup(props, { slots }) {
    useRender(() => /* @__PURE__ */ React.createElement(
      props.tag,
      {
        class: [
          "v-list-item-action",
          {
            "v-list-item-action--start": props.start,
            "v-list-item-action--end": props.end
          },
          props.class
        ],
        style: props.style,
        "v-slots": slots
      }
    ));
    return {};
  }
});
const makeVListItemMediaProps = propsFactory({
  start: Boolean,
  end: Boolean,
  ...makeComponentProps(),
  ...makeTagProps()
}, "VListItemMedia");
genericComponent()({
  name: "VListItemMedia",
  props: makeVListItemMediaProps(),
  setup(props, { slots }) {
    useRender(() => {
      return /* @__PURE__ */ React.createElement(
        props.tag,
        {
          class: [
            "v-list-item-media",
            {
              "v-list-item-media--start": props.start,
              "v-list-item-media--end": props.end
            },
            props.class
          ],
          style: props.style,
          "v-slots": slots
        }
      );
    });
    return {};
  }
});
const _VMenu = "";
const _VOverlay = "";
function elementToViewport(point, offset) {
  return {
    x: point.x + offset.x,
    y: point.y + offset.y
  };
}
function getOffset(a, b) {
  return {
    x: a.x - b.x,
    y: a.y - b.y
  };
}
function anchorToPoint(anchor, box) {
  if (anchor.side === "top" || anchor.side === "bottom") {
    const { side, align } = anchor;
    const x = align === "left" ? 0 : align === "center" ? box.width / 2 : align === "right" ? box.width : align;
    const y = side === "top" ? 0 : side === "bottom" ? box.height : side;
    return elementToViewport({ x, y }, box);
  } else if (anchor.side === "left" || anchor.side === "right") {
    const { side, align } = anchor;
    const x = side === "left" ? 0 : side === "right" ? box.width : side;
    const y = align === "top" ? 0 : align === "center" ? box.height / 2 : align === "bottom" ? box.height : align;
    return elementToViewport({ x, y }, box);
  }
  return elementToViewport({
    x: box.width / 2,
    y: box.height / 2
  }, box);
}
const locationStrategies = {
  static: staticLocationStrategy,
  // specific viewport position, usually centered
  connected: connectedLocationStrategy
  // connected to a certain element
};
const makeLocationStrategyProps = propsFactory({
  locationStrategy: {
    type: [String, Function],
    default: "static",
    validator: (val) => typeof val === "function" || val in locationStrategies
  },
  location: {
    type: String,
    default: "bottom"
  },
  origin: {
    type: String,
    default: "auto"
  },
  offset: [Number, String, Array]
}, "VOverlay-location-strategies");
function useLocationStrategies(props, data) {
  const contentStyles = ref({});
  const updateLocation = ref();
  if (IN_BROWSER) {
    useToggleScope(() => !!(data.isActive.value && props.locationStrategy), (reset) => {
      var _a, _b;
      watch(() => props.locationStrategy, reset);
      onScopeDispose(() => {
        window.removeEventListener("resize", onResize);
        updateLocation.value = void 0;
      });
      window.addEventListener("resize", onResize, { passive: true });
      if (typeof props.locationStrategy === "function") {
        updateLocation.value = (_a = props.locationStrategy(data, props, contentStyles)) == null ? void 0 : _a.updateLocation;
      } else {
        updateLocation.value = (_b = locationStrategies[props.locationStrategy](data, props, contentStyles)) == null ? void 0 : _b.updateLocation;
      }
    });
  }
  function onResize(e) {
    var _a;
    (_a = updateLocation.value) == null ? void 0 : _a.call(updateLocation, e);
  }
  return {
    contentStyles,
    updateLocation
  };
}
function staticLocationStrategy() {
}
function getIntrinsicSize(el, isRtl) {
  if (isRtl) {
    el.style.removeProperty("left");
  } else {
    el.style.removeProperty("right");
  }
  const contentBox = nullifyTransforms(el);
  if (isRtl) {
    contentBox.x += parseFloat(el.style.right || 0);
  } else {
    contentBox.x -= parseFloat(el.style.left || 0);
  }
  contentBox.y -= parseFloat(el.style.top || 0);
  return contentBox;
}
function connectedLocationStrategy(data, props, contentStyles) {
  const activatorFixed = Array.isArray(data.target.value) || isFixedPosition(data.target.value);
  if (activatorFixed) {
    Object.assign(contentStyles.value, {
      position: "fixed",
      top: 0,
      [data.isRtl.value ? "right" : "left"]: 0
    });
  }
  const { preferredAnchor, preferredOrigin } = destructComputed(() => {
    const parsedAnchor = parseAnchor(props.location, data.isRtl.value);
    const parsedOrigin = props.origin === "overlap" ? parsedAnchor : props.origin === "auto" ? flipSide(parsedAnchor) : parseAnchor(props.origin, data.isRtl.value);
    if (parsedAnchor.side === parsedOrigin.side && parsedAnchor.align === flipAlign(parsedOrigin).align) {
      return {
        preferredAnchor: flipCorner(parsedAnchor),
        preferredOrigin: flipCorner(parsedOrigin)
      };
    } else {
      return {
        preferredAnchor: parsedAnchor,
        preferredOrigin: parsedOrigin
      };
    }
  });
  const [minWidth, minHeight, maxWidth, maxHeight] = ["minWidth", "minHeight", "maxWidth", "maxHeight"].map((key) => {
    return computed(() => {
      const val = parseFloat(props[key]);
      return isNaN(val) ? Infinity : val;
    });
  });
  const offset = computed(() => {
    if (Array.isArray(props.offset)) {
      return props.offset;
    }
    if (typeof props.offset === "string") {
      const offset2 = props.offset.split(" ").map(parseFloat);
      if (offset2.length < 2)
        offset2.push(0);
      return offset2;
    }
    return typeof props.offset === "number" ? [props.offset, 0] : [0, 0];
  });
  let observe = false;
  const observer = new ResizeObserver(() => {
    if (observe)
      updateLocation();
  });
  watch([data.target, data.contentEl], ([newTarget, newContentEl], [oldTarget, oldContentEl]) => {
    if (oldTarget && !Array.isArray(oldTarget))
      observer.unobserve(oldTarget);
    if (newTarget && !Array.isArray(newTarget))
      observer.observe(newTarget);
    if (oldContentEl)
      observer.unobserve(oldContentEl);
    if (newContentEl)
      observer.observe(newContentEl);
  }, {
    immediate: true
  });
  onScopeDispose(() => {
    observer.disconnect();
  });
  function updateLocation() {
    observe = false;
    requestAnimationFrame(() => observe = true);
    if (!data.target.value || !data.contentEl.value)
      return;
    const targetBox = getTargetBox(data.target.value);
    const contentBox = getIntrinsicSize(data.contentEl.value, data.isRtl.value);
    const scrollParents = getScrollParents(data.contentEl.value);
    const viewportMargin = 12;
    if (!scrollParents.length) {
      scrollParents.push(document.documentElement);
      if (!(data.contentEl.value.style.top && data.contentEl.value.style.left)) {
        contentBox.x -= parseFloat(document.documentElement.style.getPropertyValue("--v-body-scroll-x") || 0);
        contentBox.y -= parseFloat(document.documentElement.style.getPropertyValue("--v-body-scroll-y") || 0);
      }
    }
    const viewport = scrollParents.reduce((box, el) => {
      const rect = el.getBoundingClientRect();
      const scrollBox = new Box({
        x: el === document.documentElement ? 0 : rect.x,
        y: el === document.documentElement ? 0 : rect.y,
        width: el.clientWidth,
        height: el.clientHeight
      });
      if (box) {
        return new Box({
          x: Math.max(box.left, scrollBox.left),
          y: Math.max(box.top, scrollBox.top),
          width: Math.min(box.right, scrollBox.right) - Math.max(box.left, scrollBox.left),
          height: Math.min(box.bottom, scrollBox.bottom) - Math.max(box.top, scrollBox.top)
        });
      }
      return scrollBox;
    }, void 0);
    viewport.x += viewportMargin;
    viewport.y += viewportMargin;
    viewport.width -= viewportMargin * 2;
    viewport.height -= viewportMargin * 2;
    let placement = {
      anchor: preferredAnchor.value,
      origin: preferredOrigin.value
    };
    function checkOverflow(_placement) {
      const box = new Box(contentBox);
      const targetPoint = anchorToPoint(_placement.anchor, targetBox);
      const contentPoint = anchorToPoint(_placement.origin, box);
      let { x: x2, y: y2 } = getOffset(targetPoint, contentPoint);
      switch (_placement.anchor.side) {
        case "top":
          y2 -= offset.value[0];
          break;
        case "bottom":
          y2 += offset.value[0];
          break;
        case "left":
          x2 -= offset.value[0];
          break;
        case "right":
          x2 += offset.value[0];
          break;
      }
      switch (_placement.anchor.align) {
        case "top":
          y2 -= offset.value[1];
          break;
        case "bottom":
          y2 += offset.value[1];
          break;
        case "left":
          x2 -= offset.value[1];
          break;
        case "right":
          x2 += offset.value[1];
          break;
      }
      box.x += x2;
      box.y += y2;
      box.width = Math.min(box.width, maxWidth.value);
      box.height = Math.min(box.height, maxHeight.value);
      const overflows = getOverflow(box, viewport);
      return { overflows, x: x2, y: y2 };
    }
    let x = 0;
    let y = 0;
    const available = { x: 0, y: 0 };
    const flipped = { x: false, y: false };
    let resets = -1;
    while (true) {
      if (resets++ > 10) {
        consoleError("Infinite loop detected in connectedLocationStrategy");
        break;
      }
      const { x: _x, y: _y, overflows } = checkOverflow(placement);
      x += _x;
      y += _y;
      contentBox.x += _x;
      contentBox.y += _y;
      {
        const axis2 = getAxis(placement.anchor);
        const hasOverflowX = overflows.x.before || overflows.x.after;
        const hasOverflowY = overflows.y.before || overflows.y.after;
        let reset = false;
        ["x", "y"].forEach((key) => {
          if (key === "x" && hasOverflowX && !flipped.x || key === "y" && hasOverflowY && !flipped.y) {
            const newPlacement = { anchor: { ...placement.anchor }, origin: { ...placement.origin } };
            const flip = key === "x" ? axis2 === "y" ? flipAlign : flipSide : axis2 === "y" ? flipSide : flipAlign;
            newPlacement.anchor = flip(newPlacement.anchor);
            newPlacement.origin = flip(newPlacement.origin);
            const { overflows: newOverflows } = checkOverflow(newPlacement);
            if (newOverflows[key].before <= overflows[key].before && newOverflows[key].after <= overflows[key].after || newOverflows[key].before + newOverflows[key].after < (overflows[key].before + overflows[key].after) / 2) {
              placement = newPlacement;
              reset = flipped[key] = true;
            }
          }
        });
        if (reset)
          continue;
      }
      if (overflows.x.before) {
        x += overflows.x.before;
        contentBox.x += overflows.x.before;
      }
      if (overflows.x.after) {
        x -= overflows.x.after;
        contentBox.x -= overflows.x.after;
      }
      if (overflows.y.before) {
        y += overflows.y.before;
        contentBox.y += overflows.y.before;
      }
      if (overflows.y.after) {
        y -= overflows.y.after;
        contentBox.y -= overflows.y.after;
      }
      {
        const overflows2 = getOverflow(contentBox, viewport);
        available.x = viewport.width - overflows2.x.before - overflows2.x.after;
        available.y = viewport.height - overflows2.y.before - overflows2.y.after;
        x += overflows2.x.before;
        contentBox.x += overflows2.x.before;
        y += overflows2.y.before;
        contentBox.y += overflows2.y.before;
      }
      break;
    }
    const axis = getAxis(placement.anchor);
    Object.assign(contentStyles.value, {
      "--v-overlay-anchor-origin": `${placement.anchor.side} ${placement.anchor.align}`,
      transformOrigin: `${placement.origin.side} ${placement.origin.align}`,
      // transform: `translate(${pixelRound(x)}px, ${pixelRound(y)}px)`,
      top: convertToUnit(pixelRound(y)),
      left: data.isRtl.value ? void 0 : convertToUnit(pixelRound(x)),
      right: data.isRtl.value ? convertToUnit(pixelRound(-x)) : void 0,
      minWidth: convertToUnit(axis === "y" ? Math.min(minWidth.value, targetBox.width) : minWidth.value),
      maxWidth: convertToUnit(pixelCeil(clamp(available.x, minWidth.value === Infinity ? 0 : minWidth.value, maxWidth.value))),
      maxHeight: convertToUnit(pixelCeil(clamp(available.y, minHeight.value === Infinity ? 0 : minHeight.value, maxHeight.value)))
    });
    return {
      available,
      contentBox
    };
  }
  watch(
    () => [
      preferredAnchor.value,
      preferredOrigin.value,
      props.offset,
      props.minWidth,
      props.minHeight,
      props.maxWidth,
      props.maxHeight
    ],
    () => updateLocation()
  );
  nextTick(() => {
    const result = updateLocation();
    if (!result)
      return;
    const { available, contentBox } = result;
    if (contentBox.height > available.y) {
      requestAnimationFrame(() => {
        updateLocation();
        requestAnimationFrame(() => {
          updateLocation();
        });
      });
    }
  });
  return { updateLocation };
}
function pixelRound(val) {
  return Math.round(val * devicePixelRatio) / devicePixelRatio;
}
function pixelCeil(val) {
  return Math.ceil(val * devicePixelRatio) / devicePixelRatio;
}
let clean = true;
const frames = [];
function requestNewFrame(cb) {
  if (!clean || frames.length) {
    frames.push(cb);
    run();
  } else {
    clean = false;
    cb();
    run();
  }
}
let raf = -1;
function run() {
  cancelAnimationFrame(raf);
  raf = requestAnimationFrame(() => {
    const frame = frames.shift();
    if (frame)
      frame();
    if (frames.length)
      run();
    else
      clean = true;
  });
}
const scrollStrategies = {
  none: null,
  close: closeScrollStrategy,
  block: blockScrollStrategy,
  reposition: repositionScrollStrategy
};
const makeScrollStrategyProps = propsFactory({
  scrollStrategy: {
    type: [String, Function],
    default: "block",
    validator: (val) => typeof val === "function" || val in scrollStrategies
  }
}, "VOverlay-scroll-strategies");
function useScrollStrategies(props, data) {
  if (!IN_BROWSER)
    return;
  let scope;
  watchEffect(async () => {
    scope == null ? void 0 : scope.stop();
    if (!(data.isActive.value && props.scrollStrategy))
      return;
    scope = effectScope();
    await new Promise((resolve) => setTimeout(resolve));
    scope.active && scope.run(() => {
      var _a;
      if (typeof props.scrollStrategy === "function") {
        props.scrollStrategy(data, props, scope);
      } else {
        (_a = scrollStrategies[props.scrollStrategy]) == null ? void 0 : _a.call(scrollStrategies, data, props, scope);
      }
    });
  });
  onScopeDispose(() => {
    scope == null ? void 0 : scope.stop();
  });
}
function closeScrollStrategy(data) {
  function onScroll(e) {
    data.isActive.value = false;
  }
  bindScroll(data.targetEl.value ?? data.contentEl.value, onScroll);
}
function blockScrollStrategy(data, props) {
  var _a;
  const offsetParent = (_a = data.root.value) == null ? void 0 : _a.offsetParent;
  const scrollElements = [.../* @__PURE__ */ new Set([
    ...getScrollParents(data.targetEl.value, props.contained ? offsetParent : void 0),
    ...getScrollParents(data.contentEl.value, props.contained ? offsetParent : void 0)
  ])].filter((el) => !el.classList.contains("v-overlay-scroll-blocked"));
  const scrollbarWidth = window.innerWidth - document.documentElement.offsetWidth;
  const scrollableParent = ((el) => hasScrollbar(el) && el)(offsetParent || document.documentElement);
  if (scrollableParent) {
    data.root.value.classList.add("v-overlay--scroll-blocked");
  }
  scrollElements.forEach((el, i) => {
    el.style.setProperty("--v-body-scroll-x", convertToUnit(-el.scrollLeft));
    el.style.setProperty("--v-body-scroll-y", convertToUnit(-el.scrollTop));
    if (el !== document.documentElement) {
      el.style.setProperty("--v-scrollbar-offset", convertToUnit(scrollbarWidth));
    }
    el.classList.add("v-overlay-scroll-blocked");
  });
  onScopeDispose(() => {
    scrollElements.forEach((el, i) => {
      const x = parseFloat(el.style.getPropertyValue("--v-body-scroll-x"));
      const y = parseFloat(el.style.getPropertyValue("--v-body-scroll-y"));
      const scrollBehavior = el.style.scrollBehavior;
      el.style.scrollBehavior = "auto";
      el.style.removeProperty("--v-body-scroll-x");
      el.style.removeProperty("--v-body-scroll-y");
      el.style.removeProperty("--v-scrollbar-offset");
      el.classList.remove("v-overlay-scroll-blocked");
      el.scrollLeft = -x;
      el.scrollTop = -y;
      el.style.scrollBehavior = scrollBehavior;
    });
    if (scrollableParent) {
      data.root.value.classList.remove("v-overlay--scroll-blocked");
    }
  });
}
function repositionScrollStrategy(data, props, scope) {
  let slow = false;
  let raf2 = -1;
  let ric = -1;
  function update(e) {
    requestNewFrame(() => {
      var _a, _b;
      const start = performance.now();
      (_b = (_a = data.updateLocation).value) == null ? void 0 : _b.call(_a, e);
      const time = performance.now() - start;
      slow = time / (1e3 / 60) > 2;
    });
  }
  ric = (typeof requestIdleCallback === "undefined" ? (cb) => cb() : requestIdleCallback)(() => {
    scope.run(() => {
      bindScroll(data.targetEl.value ?? data.contentEl.value, (e) => {
        if (slow) {
          cancelAnimationFrame(raf2);
          raf2 = requestAnimationFrame(() => {
            raf2 = requestAnimationFrame(() => {
              update(e);
            });
          });
        } else {
          update(e);
        }
      });
    });
  });
  onScopeDispose(() => {
    typeof cancelIdleCallback !== "undefined" && cancelIdleCallback(ric);
    cancelAnimationFrame(raf2);
  });
}
function bindScroll(el, onScroll) {
  const scrollElements = [document, ...getScrollParents(el)];
  scrollElements.forEach((el2) => {
    el2.addEventListener("scroll", onScroll, { passive: true });
  });
  onScopeDispose(() => {
    scrollElements.forEach((el2) => {
      el2.removeEventListener("scroll", onScroll);
    });
  });
}
const VMenuSymbol = Symbol.for("vuetify:v-menu");
const makeDelayProps = propsFactory({
  closeDelay: [Number, String],
  openDelay: [Number, String]
}, "delay");
function useDelay(props, cb) {
  let clearDelay = () => {
  };
  function runDelay(isOpening) {
    clearDelay == null ? void 0 : clearDelay();
    const delay = Number(isOpening ? props.openDelay : props.closeDelay);
    return new Promise((resolve) => {
      clearDelay = defer(delay, () => {
        cb == null ? void 0 : cb(isOpening);
        resolve(isOpening);
      });
    });
  }
  function runOpenDelay() {
    return runDelay(true);
  }
  function runCloseDelay() {
    return runDelay(false);
  }
  return {
    clearDelay,
    runOpenDelay,
    runCloseDelay
  };
}
const makeActivatorProps = propsFactory({
  target: [String, Object],
  activator: [String, Object],
  activatorProps: {
    type: Object,
    default: () => ({})
  },
  openOnClick: {
    type: Boolean,
    default: void 0
  },
  openOnHover: Boolean,
  openOnFocus: {
    type: Boolean,
    default: void 0
  },
  closeOnContentClick: Boolean,
  ...makeDelayProps()
}, "VOverlay-activator");
function useActivator(props, { isActive, isTop }) {
  const vm = getCurrentInstance("useActivator");
  const activatorEl = ref();
  let isHovered = false;
  let isFocused = false;
  let firstEnter = true;
  const openOnFocus = computed(() => props.openOnFocus || props.openOnFocus == null && props.openOnHover);
  const openOnClick = computed(() => props.openOnClick || props.openOnClick == null && !props.openOnHover && !openOnFocus.value);
  const { runOpenDelay, runCloseDelay } = useDelay(props, (value) => {
    if (value === (props.openOnHover && isHovered || openOnFocus.value && isFocused) && !(props.openOnHover && isActive.value && !isTop.value)) {
      if (isActive.value !== value) {
        firstEnter = true;
      }
      isActive.value = value;
    }
  });
  const cursorTarget = ref();
  const availableEvents = {
    onClick: (e) => {
      e.stopPropagation();
      activatorEl.value = e.currentTarget || e.target;
      if (!isActive.value) {
        cursorTarget.value = [e.clientX, e.clientY];
      }
      isActive.value = !isActive.value;
    },
    onMouseenter: (e) => {
      var _a;
      if ((_a = e.sourceCapabilities) == null ? void 0 : _a.firesTouchEvents)
        return;
      isHovered = true;
      activatorEl.value = e.currentTarget || e.target;
      runOpenDelay();
    },
    onMouseleave: (e) => {
      isHovered = false;
      runCloseDelay();
    },
    onFocus: (e) => {
      if (matchesSelector(e.target, ":focus-visible") === false)
        return;
      isFocused = true;
      e.stopPropagation();
      activatorEl.value = e.currentTarget || e.target;
      runOpenDelay();
    },
    onBlur: (e) => {
      isFocused = false;
      e.stopPropagation();
      runCloseDelay();
    }
  };
  const activatorEvents = computed(() => {
    const events = {};
    if (openOnClick.value) {
      events.onClick = availableEvents.onClick;
    }
    if (props.openOnHover) {
      events.onMouseenter = availableEvents.onMouseenter;
      events.onMouseleave = availableEvents.onMouseleave;
    }
    if (openOnFocus.value) {
      events.onFocus = availableEvents.onFocus;
      events.onBlur = availableEvents.onBlur;
    }
    return events;
  });
  const contentEvents = computed(() => {
    const events = {};
    if (props.openOnHover) {
      events.onMouseenter = () => {
        isHovered = true;
        runOpenDelay();
      };
      events.onMouseleave = () => {
        isHovered = false;
        runCloseDelay();
      };
    }
    if (openOnFocus.value) {
      events.onFocusin = () => {
        isFocused = true;
        runOpenDelay();
      };
      events.onFocusout = () => {
        isFocused = false;
        runCloseDelay();
      };
    }
    if (props.closeOnContentClick) {
      const menu = inject(VMenuSymbol, null);
      events.onClick = () => {
        isActive.value = false;
        menu == null ? void 0 : menu.closeParents();
      };
    }
    return events;
  });
  const scrimEvents = computed(() => {
    const events = {};
    if (props.openOnHover) {
      events.onMouseenter = () => {
        if (firstEnter) {
          isHovered = true;
          firstEnter = false;
          runOpenDelay();
        }
      };
      events.onMouseleave = () => {
        isHovered = false;
        runCloseDelay();
      };
    }
    return events;
  });
  watch(isTop, (val) => {
    if (val && (props.openOnHover && !isHovered && (!openOnFocus.value || !isFocused) || openOnFocus.value && !isFocused && (!props.openOnHover || !isHovered))) {
      isActive.value = false;
    }
  });
  watch(isActive, (val) => {
    if (!val) {
      setTimeout(() => {
        cursorTarget.value = void 0;
      });
    }
  }, { flush: "post" });
  const activatorRef = templateRef();
  watchEffect(() => {
    if (!activatorRef.value)
      return;
    nextTick(() => {
      activatorEl.value = activatorRef.el;
    });
  });
  const targetRef = templateRef();
  const target = computed(() => {
    if (props.target === "cursor" && cursorTarget.value)
      return cursorTarget.value;
    if (targetRef.value)
      return targetRef.el;
    return getTarget(props.target, vm) || activatorEl.value;
  });
  const targetEl = computed(() => {
    return Array.isArray(target.value) ? void 0 : target.value;
  });
  let scope;
  watch(() => !!props.activator, (val) => {
    if (val && IN_BROWSER) {
      scope = effectScope();
      scope.run(() => {
        _useActivator(props, vm, { activatorEl, activatorEvents });
      });
    } else if (scope) {
      scope.stop();
    }
  }, { flush: "post", immediate: true });
  onScopeDispose(() => {
    scope == null ? void 0 : scope.stop();
  });
  return { activatorEl, activatorRef, target, targetEl, targetRef, activatorEvents, contentEvents, scrimEvents };
}
function _useActivator(props, vm, { activatorEl, activatorEvents }) {
  watch(() => props.activator, (val, oldVal) => {
    if (oldVal && val !== oldVal) {
      const activator = getActivator(oldVal);
      activator && unbindActivatorProps(activator);
    }
    if (val) {
      nextTick(() => bindActivatorProps());
    }
  }, { immediate: true });
  watch(() => props.activatorProps, () => {
    bindActivatorProps();
  });
  onScopeDispose(() => {
    unbindActivatorProps();
  });
  function bindActivatorProps(el = getActivator(), _props = props.activatorProps) {
    if (!el)
      return;
    bindProps(el, mergeProps(activatorEvents.value, _props));
  }
  function unbindActivatorProps(el = getActivator(), _props = props.activatorProps) {
    if (!el)
      return;
    unbindProps(el, mergeProps(activatorEvents.value, _props));
  }
  function getActivator(selector = props.activator) {
    const activator = getTarget(selector, vm);
    activatorEl.value = (activator == null ? void 0 : activator.nodeType) === Node.ELEMENT_NODE ? activator : void 0;
    return activatorEl.value;
  }
}
function getTarget(selector, vm) {
  var _a, _b;
  if (!selector)
    return;
  let target;
  if (selector === "parent") {
    let el = (_b = (_a = vm == null ? void 0 : vm.proxy) == null ? void 0 : _a.$el) == null ? void 0 : _b.parentNode;
    while (el == null ? void 0 : el.hasAttribute("data-no-activator")) {
      el = el.parentNode;
    }
    target = el;
  } else if (typeof selector === "string") {
    target = document.querySelector(selector);
  } else if ("$el" in selector) {
    target = selector.$el;
  } else {
    target = selector;
  }
  return target;
}
function useHydration() {
  if (!IN_BROWSER)
    return shallowRef(false);
  const { ssr } = useDisplay();
  if (ssr) {
    const isMounted = shallowRef(false);
    onMounted(() => {
      isMounted.value = true;
    });
    return isMounted;
  } else {
    return shallowRef(true);
  }
}
const makeLazyProps = propsFactory({
  eager: Boolean
}, "lazy");
function useLazy(props, active) {
  const isBooted = shallowRef(false);
  const hasContent = computed(() => isBooted.value || props.eager || active.value);
  watch(active, () => isBooted.value = true);
  function onAfterLeave() {
    if (!props.eager)
      isBooted.value = false;
  }
  return { isBooted, hasContent, onAfterLeave };
}
function useScopeId() {
  const vm = getCurrentInstance("useScopeId");
  const scopeId = vm.vnode.scopeId;
  return { scopeId: scopeId ? { [scopeId]: "" } : void 0 };
}
const StackSymbol = Symbol.for("vuetify:stack");
const globalStack = reactive([]);
function useStack(isActive, zIndex, disableGlobalStack) {
  const vm = getCurrentInstance("useStack");
  const createStackEntry = !disableGlobalStack;
  const parent = inject(StackSymbol, void 0);
  const stack = reactive({
    activeChildren: /* @__PURE__ */ new Set()
  });
  provide(StackSymbol, stack);
  const _zIndex = shallowRef(+zIndex.value);
  useToggleScope(isActive, () => {
    var _a;
    const lastZIndex = (_a = globalStack.at(-1)) == null ? void 0 : _a[1];
    _zIndex.value = lastZIndex ? lastZIndex + 10 : +zIndex.value;
    if (createStackEntry) {
      globalStack.push([vm.uid, _zIndex.value]);
    }
    parent == null ? void 0 : parent.activeChildren.add(vm.uid);
    onScopeDispose(() => {
      if (createStackEntry) {
        const idx = toRaw(globalStack).findIndex((v) => v[0] === vm.uid);
        globalStack.splice(idx, 1);
      }
      parent == null ? void 0 : parent.activeChildren.delete(vm.uid);
    });
  });
  const globalTop = shallowRef(true);
  if (createStackEntry) {
    watchEffect(() => {
      var _a;
      const _isTop = ((_a = globalStack.at(-1)) == null ? void 0 : _a[0]) === vm.uid;
      setTimeout(() => globalTop.value = _isTop);
    });
  }
  const localTop = computed(() => !stack.activeChildren.size);
  return {
    globalTop: readonly(globalTop),
    localTop,
    stackStyles: computed(() => ({ zIndex: _zIndex.value }))
  };
}
function useTeleport(target) {
  const teleportTarget = computed(() => {
    const _target = target.value;
    if (_target === true || !IN_BROWSER)
      return void 0;
    const targetElement = _target === false ? document.body : typeof _target === "string" ? document.querySelector(_target) : _target;
    if (targetElement == null) {
      warn(`Unable to locate target ${_target}`);
      return void 0;
    }
    let container = targetElement.querySelector(":scope > .v-overlay-container");
    if (!container) {
      container = document.createElement("div");
      container.className = "v-overlay-container";
      targetElement.appendChild(container);
    }
    return container;
  });
  return { teleportTarget };
}
function defaultConditional() {
  return true;
}
function checkEvent(e, el, binding) {
  if (!e || checkIsActive(e, binding) === false)
    return false;
  const root = attachedRoot(el);
  if (typeof ShadowRoot !== "undefined" && root instanceof ShadowRoot && root.host === e.target)
    return false;
  const elements = (typeof binding.value === "object" && binding.value.include || (() => []))();
  elements.push(el);
  return !elements.some((el2) => el2 == null ? void 0 : el2.contains(e.target));
}
function checkIsActive(e, binding) {
  const isActive = typeof binding.value === "object" && binding.value.closeConditional || defaultConditional;
  return isActive(e);
}
function directive(e, el, binding) {
  const handler = typeof binding.value === "function" ? binding.value : binding.value.handler;
  el._clickOutside.lastMousedownWasOutside && checkEvent(e, el, binding) && setTimeout(() => {
    checkIsActive(e, binding) && handler && handler(e);
  }, 0);
}
function handleShadow(el, callback) {
  const root = attachedRoot(el);
  callback(document);
  if (typeof ShadowRoot !== "undefined" && root instanceof ShadowRoot) {
    callback(root);
  }
}
const ClickOutside = {
  // [data-app] may not be found
  // if using bind, inserted makes
  // sure that the root element is
  // available, iOS does not support
  // clicks on body
  mounted(el, binding) {
    const onClick = (e) => directive(e, el, binding);
    const onMousedown = (e) => {
      el._clickOutside.lastMousedownWasOutside = checkEvent(e, el, binding);
    };
    handleShadow(el, (app) => {
      app.addEventListener("click", onClick, true);
      app.addEventListener("mousedown", onMousedown, true);
    });
    if (!el._clickOutside) {
      el._clickOutside = {
        lastMousedownWasOutside: false
      };
    }
    el._clickOutside[binding.instance.$.uid] = {
      onClick,
      onMousedown
    };
  },
  unmounted(el, binding) {
    if (!el._clickOutside)
      return;
    handleShadow(el, (app) => {
      var _a;
      if (!app || !((_a = el._clickOutside) == null ? void 0 : _a[binding.instance.$.uid]))
        return;
      const { onClick, onMousedown } = el._clickOutside[binding.instance.$.uid];
      app.removeEventListener("click", onClick, true);
      app.removeEventListener("mousedown", onMousedown, true);
    });
    delete el._clickOutside[binding.instance.$.uid];
  }
};
function Scrim(props) {
  const { modelValue, color, ...rest } = props;
  return /* @__PURE__ */ React.createElement(Transition, { name: "fade-transition", appear: true }, props.modelValue && /* @__PURE__ */ React.createElement(
    "div",
    {
      class: [
        "v-overlay__scrim",
        props.color.backgroundColorClasses.value
      ],
      style: props.color.backgroundColorStyles.value,
      ...rest
    }
  ));
}
const makeVOverlayProps = propsFactory({
  absolute: Boolean,
  attach: [Boolean, String, Object],
  closeOnBack: {
    type: Boolean,
    default: true
  },
  contained: Boolean,
  contentClass: null,
  contentProps: null,
  disabled: Boolean,
  opacity: [Number, String],
  noClickAnimation: Boolean,
  modelValue: Boolean,
  persistent: Boolean,
  scrim: {
    type: [Boolean, String],
    default: true
  },
  zIndex: {
    type: [Number, String],
    default: 2e3
  },
  ...makeActivatorProps(),
  ...makeComponentProps(),
  ...makeDimensionProps(),
  ...makeLazyProps(),
  ...makeLocationStrategyProps(),
  ...makeScrollStrategyProps(),
  ...makeThemeProps(),
  ...makeTransitionProps()
}, "VOverlay");
const VOverlay = genericComponent()({
  name: "VOverlay",
  directives: { ClickOutside },
  inheritAttrs: false,
  props: {
    _disableGlobalStack: Boolean,
    ...makeVOverlayProps()
  },
  emits: {
    "click:outside": (e) => true,
    "update:modelValue": (value) => true,
    afterEnter: () => true,
    afterLeave: () => true
  },
  setup(props, { slots, attrs, emit }) {
    const model = useProxiedModel(props, "modelValue");
    const isActive = computed({
      get: () => model.value,
      set: (v) => {
        if (!(v && props.disabled))
          model.value = v;
      }
    });
    const { teleportTarget } = useTeleport(computed(() => props.attach || props.contained));
    const { themeClasses } = provideTheme(props);
    const { rtlClasses, isRtl } = useRtl();
    const { hasContent, onAfterLeave: _onAfterLeave } = useLazy(props, isActive);
    const scrimColor = useBackgroundColor(computed(() => {
      return typeof props.scrim === "string" ? props.scrim : null;
    }));
    const { globalTop, localTop, stackStyles } = useStack(isActive, toRef(props, "zIndex"), props._disableGlobalStack);
    const {
      activatorEl,
      activatorRef,
      target,
      targetEl,
      targetRef,
      activatorEvents,
      contentEvents,
      scrimEvents
    } = useActivator(props, { isActive, isTop: localTop });
    const { dimensionStyles } = useDimension(props);
    const isMounted = useHydration();
    const { scopeId } = useScopeId();
    watch(() => props.disabled, (v) => {
      if (v)
        isActive.value = false;
    });
    const root = ref();
    const scrimEl = ref();
    const contentEl = ref();
    const { contentStyles, updateLocation } = useLocationStrategies(props, {
      isRtl,
      contentEl,
      target,
      isActive
    });
    useScrollStrategies(props, {
      root,
      contentEl,
      targetEl,
      isActive,
      updateLocation
    });
    function onClickOutside(e) {
      emit("click:outside", e);
      if (!props.persistent)
        isActive.value = false;
      else
        animateClick();
    }
    function closeConditional(e) {
      return isActive.value && globalTop.value && // If using scrim, only close if clicking on it rather than anything opened on top
      (!props.scrim || e.target === scrimEl.value);
    }
    IN_BROWSER && watch(isActive, (val) => {
      if (val) {
        window.addEventListener("keydown", onKeydown);
      } else {
        window.removeEventListener("keydown", onKeydown);
      }
    }, { immediate: true });
    onBeforeUnmount(() => {
      if (!IN_BROWSER)
        return;
      window.removeEventListener("keydown", onKeydown);
    });
    function onKeydown(e) {
      var _a, _b;
      if (e.key === "Escape" && globalTop.value) {
        if (!props.persistent) {
          isActive.value = false;
          if ((_a = contentEl.value) == null ? void 0 : _a.contains(document.activeElement)) {
            (_b = activatorEl.value) == null ? void 0 : _b.focus();
          }
        } else
          animateClick();
      }
    }
    const router = useRouter();
    useToggleScope(() => props.closeOnBack, () => {
      useBackButton(router, (next) => {
        if (globalTop.value && isActive.value) {
          next(false);
          if (!props.persistent)
            isActive.value = false;
          else
            animateClick();
        } else {
          next();
        }
      });
    });
    const top = ref();
    watch(() => isActive.value && (props.absolute || props.contained) && teleportTarget.value == null, (val) => {
      if (val) {
        const scrollParent = getScrollParent(root.value);
        if (scrollParent && scrollParent !== document.scrollingElement) {
          top.value = scrollParent.scrollTop;
        }
      }
    });
    function animateClick() {
      if (props.noClickAnimation)
        return;
      contentEl.value && animate(contentEl.value, [
        { transformOrigin: "center" },
        { transform: "scale(1.03)" },
        { transformOrigin: "center" }
      ], {
        duration: 150,
        easing: standardEasing
      });
    }
    function onAfterEnter() {
      emit("afterEnter");
    }
    function onAfterLeave() {
      _onAfterLeave();
      emit("afterLeave");
    }
    useRender(() => {
      var _a, _b;
      return /* @__PURE__ */ React.createElement(React.Fragment, null, (_a = slots.activator) == null ? void 0 : _a.call(slots, {
        isActive: isActive.value,
        targetRef,
        props: mergeProps({
          ref: activatorRef
        }, activatorEvents.value, props.activatorProps)
      }), isMounted.value && hasContent.value && /* @__PURE__ */ React.createElement(
        Teleport,
        {
          disabled: !teleportTarget.value,
          to: teleportTarget.value
        },
        /* @__PURE__ */ React.createElement(
          "div",
          {
            class: [
              "v-overlay",
              {
                "v-overlay--absolute": props.absolute || props.contained,
                "v-overlay--active": isActive.value,
                "v-overlay--contained": props.contained
              },
              themeClasses.value,
              rtlClasses.value,
              props.class
            ],
            style: [
              stackStyles.value,
              {
                "--v-overlay-opacity": props.opacity,
                top: convertToUnit(top.value)
              },
              props.style
            ],
            ref: root,
            ...scopeId,
            ...attrs
          },
          /* @__PURE__ */ React.createElement(
            Scrim,
            {
              color: scrimColor,
              modelValue: isActive.value && !!props.scrim,
              ref: scrimEl,
              ...scrimEvents.value
            }
          ),
          /* @__PURE__ */ React.createElement(
            MaybeTransition,
            {
              appear: true,
              persisted: true,
              transition: props.transition,
              target: target.value,
              onAfterEnter,
              onAfterLeave
            },
            /* @__PURE__ */ React.createElement(
              "div",
              {
                ref: contentEl,
                "v-show": isActive.value,
                "v-click-outside": { handler: onClickOutside, closeConditional, include: () => [activatorEl.value] },
                class: [
                  "v-overlay__content",
                  props.contentClass
                ],
                style: [
                  dimensionStyles.value,
                  contentStyles.value
                ],
                ...contentEvents.value,
                ...props.contentProps
              },
              (_b = slots.default) == null ? void 0 : _b.call(slots, { isActive })
            )
          )
        )
      ));
    });
    return {
      activatorEl,
      scrimEl,
      target,
      animateClick,
      contentEl,
      globalTop,
      localTop,
      updateLocation
    };
  }
});
const makeVMenuProps = propsFactory({
  // TODO
  // disableKeys: Boolean,
  id: String,
  ...omit(makeVOverlayProps({
    closeDelay: 250,
    closeOnContentClick: true,
    locationStrategy: "connected",
    openDelay: 300,
    scrim: false,
    scrollStrategy: "reposition",
    transition: { component: VDialogTransition }
  }), ["absolute"])
}, "VMenu");
const VMenu = genericComponent()({
  name: "VMenu",
  props: makeVMenuProps(),
  emits: {
    "update:modelValue": (value) => true
  },
  setup(props, { slots }) {
    const isActive = useProxiedModel(props, "modelValue");
    const { scopeId } = useScopeId();
    const uid = getUid();
    const id = computed(() => props.id || `v-menu-${uid}`);
    const overlay = ref();
    const parent = inject(VMenuSymbol, null);
    const openChildren = shallowRef(0);
    provide(VMenuSymbol, {
      register() {
        ++openChildren.value;
      },
      unregister() {
        --openChildren.value;
      },
      closeParents(e) {
        setTimeout(() => {
          if (!openChildren.value && !props.persistent && (e == null || e && !isClickInsideElement(e, overlay.value.contentEl))) {
            isActive.value = false;
            parent == null ? void 0 : parent.closeParents();
          }
        }, 40);
      }
    });
    async function onFocusIn(e) {
      var _a, _b, _c;
      const before = e.relatedTarget;
      const after = e.target;
      await nextTick();
      if (isActive.value && before !== after && ((_a = overlay.value) == null ? void 0 : _a.contentEl) && // We're the topmost menu
      ((_b = overlay.value) == null ? void 0 : _b.globalTop) && // It isn't the document or the menu body
      ![document, overlay.value.contentEl].includes(after) && // It isn't inside the menu body
      !overlay.value.contentEl.contains(after)) {
        const focusable = focusableChildren(overlay.value.contentEl);
        (_c = focusable[0]) == null ? void 0 : _c.focus();
      }
    }
    watch(isActive, (val) => {
      if (val) {
        parent == null ? void 0 : parent.register();
        document.addEventListener("focusin", onFocusIn, { once: true });
      } else {
        parent == null ? void 0 : parent.unregister();
        document.removeEventListener("focusin", onFocusIn);
      }
    });
    function onClickOutside(e) {
      parent == null ? void 0 : parent.closeParents(e);
    }
    function onKeydown(e) {
      var _a, _b, _c;
      if (props.disabled)
        return;
      if (e.key === "Tab" || e.key === "Enter" && !props.closeOnContentClick) {
        if (e.key === "Enter" && e.target instanceof HTMLTextAreaElement)
          return;
        if (e.key === "Enter")
          e.preventDefault();
        const nextElement = getNextElement(
          focusableChildren((_a = overlay.value) == null ? void 0 : _a.contentEl, false),
          e.shiftKey ? "prev" : "next",
          (el) => el.tabIndex >= 0
        );
        if (!nextElement) {
          isActive.value = false;
          (_c = (_b = overlay.value) == null ? void 0 : _b.activatorEl) == null ? void 0 : _c.focus();
        }
      } else if (["Enter", " "].includes(e.key) && props.closeOnContentClick) {
        isActive.value = false;
        parent == null ? void 0 : parent.closeParents();
      }
    }
    function onActivatorKeydown(e) {
      var _a;
      if (props.disabled)
        return;
      const el = (_a = overlay.value) == null ? void 0 : _a.contentEl;
      if (el && isActive.value) {
        if (e.key === "ArrowDown") {
          e.preventDefault();
          focusChild(el, "next");
        } else if (e.key === "ArrowUp") {
          e.preventDefault();
          focusChild(el, "prev");
        }
      } else if (["ArrowDown", "ArrowUp"].includes(e.key)) {
        isActive.value = true;
        e.preventDefault();
        setTimeout(() => setTimeout(() => onActivatorKeydown(e)));
      }
    }
    const activatorProps = computed(
      () => mergeProps({
        "aria-haspopup": "menu",
        "aria-expanded": String(isActive.value),
        "aria-owns": id.value,
        onKeydown: onActivatorKeydown
      }, props.activatorProps)
    );
    useRender(() => {
      const overlayProps = VOverlay.filterProps(props);
      return /* @__PURE__ */ React.createElement(
        VOverlay,
        {
          ref: overlay,
          id: id.value,
          class: [
            "v-menu",
            props.class
          ],
          style: props.style,
          ...overlayProps,
          "v-model": isActive.value,
          absolute: true,
          activatorProps: activatorProps.value,
          "onClick:outside": onClickOutside,
          onKeydown,
          ...scopeId
        },
        {
          activator: slots.activator,
          default: (...args) => {
            var _a;
            return /* @__PURE__ */ React.createElement(VDefaultsProvider, { root: "VMenu" }, (_a = slots.default) == null ? void 0 : _a.call(slots, ...args));
          }
        }
      );
    });
    return forwardRefs({ id, ΨopenChildren: openChildren }, overlay);
  }
});
const _VSelect = "";
const _VVirtualScroll = "";
const makeVVirtualScrollItemProps = propsFactory({
  renderless: Boolean,
  ...makeComponentProps()
}, "VVirtualScrollItem");
const VVirtualScrollItem = genericComponent()({
  name: "VVirtualScrollItem",
  inheritAttrs: false,
  props: makeVVirtualScrollItemProps(),
  emits: {
    "update:height": (height) => true
  },
  setup(props, { attrs, emit, slots }) {
    const { resizeRef, contentRect } = useResizeObserver(void 0, "border");
    watch(() => {
      var _a;
      return (_a = contentRect.value) == null ? void 0 : _a.height;
    }, (height) => {
      if (height != null)
        emit("update:height", height);
    });
    useRender(() => {
      var _a, _b;
      return props.renderless ? /* @__PURE__ */ React.createElement(React.Fragment, null, (_a = slots.default) == null ? void 0 : _a.call(slots, { itemRef: resizeRef })) : /* @__PURE__ */ React.createElement(
        "div",
        {
          ref: resizeRef,
          class: [
            "v-virtual-scroll__item",
            props.class
          ],
          style: props.style,
          ...attrs
        },
        (_b = slots.default) == null ? void 0 : _b.call(slots)
      );
    });
  }
});
const UP = -1;
const DOWN = 1;
const BUFFER_PX = 100;
const makeVirtualProps = propsFactory({
  itemHeight: {
    type: [Number, String],
    default: null
  },
  height: [Number, String]
}, "virtual");
function useVirtual(props, items) {
  const display = useDisplay();
  const itemHeight = shallowRef(0);
  watchEffect(() => {
    itemHeight.value = parseFloat(props.itemHeight || 0);
  });
  const first = shallowRef(0);
  const last = shallowRef(Math.ceil(
    // Assume 16px items filling the entire screen height if
    // not provided. This is probably incorrect but it minimises
    // the chance of ending up with empty space at the bottom.
    // The default value is set here to avoid poisoning getSize()
    (parseInt(props.height) || display.height.value) / (itemHeight.value || 16)
  ) || 1);
  const paddingTop = shallowRef(0);
  const paddingBottom = shallowRef(0);
  const containerRef = ref();
  const markerRef = ref();
  let markerOffset = 0;
  const { resizeRef, contentRect } = useResizeObserver();
  watchEffect(() => {
    resizeRef.value = containerRef.value;
  });
  const viewportHeight = computed(() => {
    var _a;
    return containerRef.value === document.documentElement ? display.height.value : ((_a = contentRect.value) == null ? void 0 : _a.height) || parseInt(props.height) || 0;
  });
  const hasInitialRender = computed(() => {
    return !!(containerRef.value && markerRef.value && viewportHeight.value && itemHeight.value);
  });
  let sizes = Array.from({ length: items.value.length });
  let offsets = Array.from({ length: items.value.length });
  const updateTime = shallowRef(0);
  let targetScrollIndex = -1;
  function getSize(index) {
    return sizes[index] || itemHeight.value;
  }
  const updateOffsets = debounce(() => {
    const start = performance.now();
    offsets[0] = 0;
    const length = items.value.length;
    for (let i = 1; i <= length - 1; i++) {
      offsets[i] = (offsets[i - 1] || 0) + getSize(i - 1);
    }
    updateTime.value = Math.max(updateTime.value, performance.now() - start);
  }, updateTime);
  const unwatch = watch(hasInitialRender, (v) => {
    if (!v)
      return;
    unwatch();
    markerOffset = markerRef.value.offsetTop;
    updateOffsets.immediate();
    calculateVisibleItems();
    if (!~targetScrollIndex)
      return;
    nextTick(() => {
      IN_BROWSER && window.requestAnimationFrame(() => {
        scrollToIndex(targetScrollIndex);
        targetScrollIndex = -1;
      });
    });
  });
  onScopeDispose(() => {
    updateOffsets.clear();
  });
  function handleItemResize(index, height) {
    const prevHeight = sizes[index];
    const prevMinHeight = itemHeight.value;
    itemHeight.value = prevMinHeight ? Math.min(itemHeight.value, height) : height;
    if (prevHeight !== height || prevMinHeight !== itemHeight.value) {
      sizes[index] = height;
      updateOffsets();
    }
  }
  function calculateOffset(index) {
    index = clamp(index, 0, items.value.length - 1);
    return offsets[index] || 0;
  }
  function calculateIndex(scrollTop) {
    return binaryClosest(offsets, scrollTop);
  }
  let lastScrollTop = 0;
  let scrollVelocity = 0;
  let lastScrollTime = 0;
  watch(viewportHeight, (val, oldVal) => {
    if (oldVal) {
      calculateVisibleItems();
      if (val < oldVal) {
        requestAnimationFrame(() => {
          scrollVelocity = 0;
          calculateVisibleItems();
        });
      }
    }
  });
  function handleScroll() {
    if (!containerRef.value || !markerRef.value)
      return;
    const scrollTop = containerRef.value.scrollTop;
    const scrollTime = performance.now();
    const scrollDeltaT = scrollTime - lastScrollTime;
    if (scrollDeltaT > 500) {
      scrollVelocity = Math.sign(scrollTop - lastScrollTop);
      markerOffset = markerRef.value.offsetTop;
    } else {
      scrollVelocity = scrollTop - lastScrollTop;
    }
    lastScrollTop = scrollTop;
    lastScrollTime = scrollTime;
    calculateVisibleItems();
  }
  function handleScrollend() {
    if (!containerRef.value || !markerRef.value)
      return;
    scrollVelocity = 0;
    lastScrollTime = 0;
    calculateVisibleItems();
  }
  let raf2 = -1;
  function calculateVisibleItems() {
    cancelAnimationFrame(raf2);
    raf2 = requestAnimationFrame(_calculateVisibleItems);
  }
  function _calculateVisibleItems() {
    if (!containerRef.value || !viewportHeight.value)
      return;
    const scrollTop = lastScrollTop - markerOffset;
    const direction = Math.sign(scrollVelocity);
    const startPx = Math.max(0, scrollTop - BUFFER_PX);
    const start = clamp(calculateIndex(startPx), 0, items.value.length);
    const endPx = scrollTop + viewportHeight.value + BUFFER_PX;
    const end = clamp(calculateIndex(endPx) + 1, start + 1, items.value.length);
    if (
      // Only update the side we're scrolling towards,
      // the other side will be updated incidentally
      (direction !== UP || start < first.value) && (direction !== DOWN || end > last.value)
    ) {
      const topOverflow = calculateOffset(first.value) - calculateOffset(start);
      const bottomOverflow = calculateOffset(end) - calculateOffset(last.value);
      const bufferOverflow = Math.max(topOverflow, bottomOverflow);
      if (bufferOverflow > BUFFER_PX) {
        first.value = start;
        last.value = end;
      } else {
        if (start <= 0)
          first.value = start;
        if (end >= items.value.length)
          last.value = end;
      }
    }
    paddingTop.value = calculateOffset(first.value);
    paddingBottom.value = calculateOffset(items.value.length) - calculateOffset(last.value);
  }
  function scrollToIndex(index) {
    const offset = calculateOffset(index);
    if (!containerRef.value || index && !offset) {
      targetScrollIndex = index;
    } else {
      containerRef.value.scrollTop = offset;
    }
  }
  const computedItems = computed(() => {
    return items.value.slice(first.value, last.value).map((item, index) => ({
      raw: item,
      index: index + first.value
    }));
  });
  watch(items, () => {
    sizes = Array.from({ length: items.value.length });
    offsets = Array.from({ length: items.value.length });
    updateOffsets.immediate();
    calculateVisibleItems();
  }, { deep: true });
  return {
    containerRef,
    markerRef,
    computedItems,
    paddingTop,
    paddingBottom,
    scrollToIndex,
    handleScroll,
    handleScrollend,
    handleItemResize
  };
}
function binaryClosest(arr, val) {
  let high = arr.length - 1;
  let low = 0;
  let mid = 0;
  let item = null;
  let target = -1;
  if (arr[high] < val) {
    return high;
  }
  while (low <= high) {
    mid = low + high >> 1;
    item = arr[mid];
    if (item > val) {
      high = mid - 1;
    } else if (item < val) {
      target = mid;
      low = mid + 1;
    } else if (item === val) {
      return mid;
    } else {
      return low;
    }
  }
  return target;
}
const makeVVirtualScrollProps = propsFactory({
  items: {
    type: Array,
    default: () => []
  },
  renderless: Boolean,
  ...makeVirtualProps(),
  ...makeComponentProps(),
  ...makeDimensionProps()
}, "VVirtualScroll");
const VVirtualScroll = genericComponent()({
  name: "VVirtualScroll",
  props: makeVVirtualScrollProps(),
  setup(props, { slots }) {
    const vm = getCurrentInstance("VVirtualScroll");
    const { dimensionStyles } = useDimension(props);
    const {
      containerRef,
      markerRef,
      handleScroll,
      handleScrollend,
      handleItemResize,
      scrollToIndex,
      paddingTop,
      paddingBottom,
      computedItems
    } = useVirtual(props, toRef(props, "items"));
    useToggleScope(() => props.renderless, () => {
      function handleListeners(add = false) {
        var _a, _b;
        const method = add ? "addEventListener" : "removeEventListener";
        if (containerRef.value === document.documentElement) {
          document[method]("scroll", handleScroll, { passive: true });
          document[method]("scrollend", handleScrollend);
        } else {
          (_a = containerRef.value) == null ? void 0 : _a[method]("scroll", handleScroll, { passive: true });
          (_b = containerRef.value) == null ? void 0 : _b[method]("scrollend", handleScrollend);
        }
      }
      onMounted(() => {
        containerRef.value = getScrollParent(vm.vnode.el, true);
        handleListeners(true);
      });
      onScopeDispose(handleListeners);
    });
    useRender(() => {
      const children = computedItems.value.map((item) => /* @__PURE__ */ React.createElement(
        VVirtualScrollItem,
        {
          key: item.index,
          renderless: props.renderless,
          "onUpdate:height": (height) => handleItemResize(item.index, height)
        },
        (slotProps) => {
          var _a;
          return (_a = slots.default) == null ? void 0 : _a.call(slots, { item: item.raw, index: item.index, ...slotProps });
        }
      ));
      return props.renderless ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { ref: markerRef, class: "v-virtual-scroll__spacer", style: { paddingTop: convertToUnit(paddingTop.value) } }), children, /* @__PURE__ */ React.createElement("div", { class: "v-virtual-scroll__spacer", style: { paddingBottom: convertToUnit(paddingBottom.value) } })) : /* @__PURE__ */ React.createElement(
        "div",
        {
          ref: containerRef,
          class: [
            "v-virtual-scroll",
            props.class
          ],
          onScrollPassive: handleScroll,
          onScrollend: handleScrollend,
          style: [
            dimensionStyles.value,
            props.style
          ]
        },
        /* @__PURE__ */ React.createElement(
          "div",
          {
            ref: markerRef,
            class: "v-virtual-scroll__container",
            style: {
              paddingTop: convertToUnit(paddingTop.value),
              paddingBottom: convertToUnit(paddingBottom.value)
            }
          },
          children
        )
      );
    });
    return {
      scrollToIndex
    };
  }
});
function useScrolling(listRef, textFieldRef) {
  const isScrolling = shallowRef(false);
  let scrollTimeout;
  function onListScroll(e) {
    cancelAnimationFrame(scrollTimeout);
    isScrolling.value = true;
    scrollTimeout = requestAnimationFrame(() => {
      scrollTimeout = requestAnimationFrame(() => {
        isScrolling.value = false;
      });
    });
  }
  async function finishScrolling() {
    await new Promise((resolve) => requestAnimationFrame(resolve));
    await new Promise((resolve) => requestAnimationFrame(resolve));
    await new Promise((resolve) => requestAnimationFrame(resolve));
    await new Promise((resolve) => {
      if (isScrolling.value) {
        const stop = watch(isScrolling, () => {
          stop();
          resolve();
        });
      } else
        resolve();
    });
  }
  async function onListKeydown(e) {
    var _a, _b;
    if (e.key === "Tab") {
      (_a = textFieldRef.value) == null ? void 0 : _a.focus();
    }
    if (!["PageDown", "PageUp", "Home", "End"].includes(e.key))
      return;
    const el = (_b = listRef.value) == null ? void 0 : _b.$el;
    if (!el)
      return;
    if (e.key === "Home" || e.key === "End") {
      el.scrollTo({
        top: e.key === "Home" ? 0 : el.scrollHeight,
        behavior: "smooth"
      });
    }
    await finishScrolling();
    const children = el.querySelectorAll(":scope > :not(.v-virtual-scroll__spacer)");
    if (e.key === "PageDown" || e.key === "Home") {
      const top = el.getBoundingClientRect().top;
      for (const child of children) {
        if (child.getBoundingClientRect().top >= top) {
          child.focus();
          break;
        }
      }
    } else {
      const bottom = el.getBoundingClientRect().bottom;
      for (const child of [...children].reverse()) {
        if (child.getBoundingClientRect().bottom <= bottom) {
          child.focus();
          break;
        }
      }
    }
  }
  return { onListScroll, onListKeydown };
}
const makeSelectProps = propsFactory({
  chips: Boolean,
  closableChips: Boolean,
  closeText: {
    type: String,
    default: "$vuetify.close"
  },
  openText: {
    type: String,
    default: "$vuetify.open"
  },
  eager: Boolean,
  hideNoData: Boolean,
  hideSelected: Boolean,
  listProps: {
    type: Object
  },
  menu: Boolean,
  menuIcon: {
    type: IconValue,
    default: "$dropdown"
  },
  menuProps: {
    type: Object
  },
  multiple: Boolean,
  noDataText: {
    type: String,
    default: "$vuetify.noDataText"
  },
  openOnClear: Boolean,
  itemColor: String,
  ...makeItemsProps({ itemChildren: false })
}, "Select");
const makeVSelectProps = propsFactory({
  ...makeSelectProps(),
  ...omit(makeVTextFieldProps({
    modelValue: null,
    role: "combobox"
  }), ["validationValue", "dirty", "appendInnerIcon"]),
  ...makeTransitionProps({ transition: { component: VDialogTransition } })
}, "VSelect");
genericComponent()({
  name: "VSelect",
  props: makeVSelectProps(),
  emits: {
    "update:focused": (focused) => true,
    "update:modelValue": (value) => true,
    "update:menu": (ue) => true
  },
  setup(props, { slots }) {
    const { t } = useLocale();
    const vTextFieldRef = ref();
    const vMenuRef = ref();
    const vVirtualScrollRef = ref();
    const _menu = useProxiedModel(props, "menu");
    const menu = computed({
      get: () => _menu.value,
      set: (v) => {
        var _a;
        if (_menu.value && !v && ((_a = vMenuRef.value) == null ? void 0 : _a.ΨopenChildren))
          return;
        _menu.value = v;
      }
    });
    const { items, transformIn, transformOut } = useItems(props);
    const model = useProxiedModel(
      props,
      "modelValue",
      [],
      (v) => transformIn(v === null ? [null] : wrapInArray(v)),
      (v) => {
        const transformed = transformOut(v);
        return props.multiple ? transformed : transformed[0] ?? null;
      }
    );
    const counterValue = computed(() => {
      return typeof props.counterValue === "function" ? props.counterValue(model.value) : typeof props.counterValue === "number" ? props.counterValue : model.value.length;
    });
    const form = useForm();
    const selectedValues = computed(() => model.value.map((selection) => selection.value));
    const isFocused = shallowRef(false);
    const label = computed(() => menu.value ? props.closeText : props.openText);
    let keyboardLookupPrefix = "";
    let keyboardLookupLastTime;
    const displayItems = computed(() => {
      if (props.hideSelected) {
        return items.value.filter((item) => !model.value.some((s) => props.valueComparator(s, item)));
      }
      return items.value;
    });
    const menuDisabled = computed(() => props.hideNoData && !displayItems.value.length || props.readonly || (form == null ? void 0 : form.isReadonly.value));
    const computedMenuProps = computed(() => {
      var _a;
      return {
        ...props.menuProps,
        activatorProps: {
          ...((_a = props.menuProps) == null ? void 0 : _a.activatorProps) || {},
          "aria-haspopup": "listbox"
          // Set aria-haspopup to 'listbox'
        }
      };
    });
    const listRef = ref();
    const { onListScroll, onListKeydown } = useScrolling(listRef, vTextFieldRef);
    function onClear(e) {
      if (props.openOnClear) {
        menu.value = true;
      }
    }
    function onMousedownControl() {
      if (menuDisabled.value)
        return;
      menu.value = !menu.value;
    }
    function onKeydown(e) {
      var _a, _b;
      if (!e.key || props.readonly || (form == null ? void 0 : form.isReadonly.value))
        return;
      if (["Enter", " ", "ArrowDown", "ArrowUp", "Home", "End"].includes(e.key)) {
        e.preventDefault();
      }
      if (["Enter", "ArrowDown", " "].includes(e.key)) {
        menu.value = true;
      }
      if (["Escape", "Tab"].includes(e.key)) {
        menu.value = false;
      }
      if (e.key === "Home") {
        (_a = listRef.value) == null ? void 0 : _a.focus("first");
      } else if (e.key === "End") {
        (_b = listRef.value) == null ? void 0 : _b.focus("last");
      }
      const KEYBOARD_LOOKUP_THRESHOLD = 1e3;
      function checkPrintable(e2) {
        const isPrintableChar = e2.key.length === 1;
        const noModifier = !e2.ctrlKey && !e2.metaKey && !e2.altKey;
        return isPrintableChar && noModifier;
      }
      if (props.multiple || !checkPrintable(e))
        return;
      const now = performance.now();
      if (now - keyboardLookupLastTime > KEYBOARD_LOOKUP_THRESHOLD) {
        keyboardLookupPrefix = "";
      }
      keyboardLookupPrefix += e.key.toLowerCase();
      keyboardLookupLastTime = now;
      const item = items.value.find((item2) => item2.title.toLowerCase().startsWith(keyboardLookupPrefix));
      if (item !== void 0) {
        model.value = [item];
        const index = displayItems.value.indexOf(item);
        IN_BROWSER && window.requestAnimationFrame(() => {
          var _a2;
          index >= 0 && ((_a2 = vVirtualScrollRef.value) == null ? void 0 : _a2.scrollToIndex(index));
        });
      }
    }
    function select(item, set = true) {
      if (item.props.disabled)
        return;
      if (props.multiple) {
        const index = model.value.findIndex((selection) => props.valueComparator(selection.value, item.value));
        const add = set == null ? !~index : set;
        if (~index) {
          const value = add ? [...model.value, item] : [...model.value];
          value.splice(index, 1);
          model.value = value;
        } else if (add) {
          model.value = [...model.value, item];
        }
      } else {
        const add = set !== false;
        model.value = add ? [item] : [];
        nextTick(() => {
          menu.value = false;
        });
      }
    }
    function onBlur(e) {
      var _a;
      if (!((_a = listRef.value) == null ? void 0 : _a.$el.contains(e.relatedTarget))) {
        menu.value = false;
      }
    }
    function onAfterLeave() {
      var _a;
      if (isFocused.value) {
        (_a = vTextFieldRef.value) == null ? void 0 : _a.focus();
      }
    }
    function onFocusin(e) {
      isFocused.value = true;
    }
    function onModelUpdate(v) {
      if (v == null)
        model.value = [];
      else if (matchesSelector(vTextFieldRef.value, ":autofill") || matchesSelector(vTextFieldRef.value, ":-webkit-autofill")) {
        const item = items.value.find((item2) => item2.title === v);
        if (item) {
          select(item);
        }
      } else if (vTextFieldRef.value) {
        vTextFieldRef.value.value = "";
      }
    }
    watch(menu, () => {
      if (!props.hideSelected && menu.value && model.value.length) {
        const index = displayItems.value.findIndex(
          (item) => model.value.some((s) => props.valueComparator(s.value, item.value))
        );
        IN_BROWSER && window.requestAnimationFrame(() => {
          var _a;
          index >= 0 && ((_a = vVirtualScrollRef.value) == null ? void 0 : _a.scrollToIndex(index));
        });
      }
    });
    watch(() => props.items, (newVal, oldVal) => {
      if (menu.value)
        return;
      if (isFocused.value && !oldVal.length && newVal.length) {
        menu.value = true;
      }
    });
    useRender(() => {
      const hasChips = !!(props.chips || slots.chip);
      const hasList = !!(!props.hideNoData || displayItems.value.length || slots["prepend-item"] || slots["append-item"] || slots["no-data"]);
      const isDirty = model.value.length > 0;
      const textFieldProps = VTextField.filterProps(props);
      const placeholder = isDirty || !isFocused.value && props.label && !props.persistentPlaceholder ? void 0 : props.placeholder;
      return /* @__PURE__ */ React.createElement(
        VTextField,
        {
          ref: vTextFieldRef,
          ...textFieldProps,
          modelValue: model.value.map((v) => v.props.value).join(", "),
          "onUpdate:modelValue": onModelUpdate,
          "v-model:focused": isFocused.value,
          validationValue: model.externalValue,
          counterValue: counterValue.value,
          dirty: isDirty,
          class: [
            "v-select",
            {
              "v-select--active-menu": menu.value,
              "v-select--chips": !!props.chips,
              [`v-select--${props.multiple ? "multiple" : "single"}`]: true,
              "v-select--selected": model.value.length,
              "v-select--selection-slot": !!slots.selection
            },
            props.class
          ],
          style: props.style,
          inputmode: "none",
          placeholder,
          "onClick:clear": onClear,
          "onMousedown:control": onMousedownControl,
          onBlur,
          onKeydown,
          "aria-label": t(label.value),
          title: t(label.value)
        },
        {
          ...slots,
          default: () => {
            var _a, _b, _c;
            return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
              VMenu,
              {
                ref: vMenuRef,
                "v-model": menu.value,
                activator: "parent",
                contentClass: "v-select__content",
                disabled: menuDisabled.value,
                eager: props.eager,
                maxHeight: 310,
                openOnClick: false,
                closeOnContentClick: false,
                transition: props.transition,
                onAfterLeave,
                ...computedMenuProps.value
              },
              hasList && /* @__PURE__ */ React.createElement(
                VList,
                {
                  ref: listRef,
                  selected: selectedValues.value,
                  selectStrategy: props.multiple ? "independent" : "single-independent",
                  onMousedown: (e) => e.preventDefault(),
                  onKeydown: onListKeydown,
                  onFocusin,
                  onScrollPassive: onListScroll,
                  tabindex: "-1",
                  "aria-live": "polite",
                  color: props.itemColor ?? props.color,
                  ...props.listProps
                },
                (_a = slots["prepend-item"]) == null ? void 0 : _a.call(slots),
                !displayItems.value.length && !props.hideNoData && (((_b = slots["no-data"]) == null ? void 0 : _b.call(slots)) ?? /* @__PURE__ */ React.createElement(VListItem, { title: t(props.noDataText) })),
                /* @__PURE__ */ React.createElement(VVirtualScroll, { ref: vVirtualScrollRef, renderless: true, items: displayItems.value }, ({ item, index, itemRef }) => {
                  var _a2;
                  const itemProps = mergeProps(item.props, {
                    ref: itemRef,
                    key: index,
                    onClick: () => select(item, null)
                  });
                  return ((_a2 = slots.item) == null ? void 0 : _a2.call(slots, {
                    item,
                    index,
                    props: itemProps
                  })) ?? /* @__PURE__ */ React.createElement(VListItem, { ...itemProps, role: "option" }, {
                    prepend: ({ isSelected }) => /* @__PURE__ */ React.createElement(React.Fragment, null, props.multiple && !props.hideSelected ? /* @__PURE__ */ React.createElement(
                      VCheckboxBtn,
                      {
                        key: item.value,
                        modelValue: isSelected,
                        ripple: false,
                        tabindex: "-1"
                      }
                    ) : void 0, item.props.prependAvatar && /* @__PURE__ */ React.createElement(VAvatar, { image: item.props.prependAvatar }), item.props.prependIcon && /* @__PURE__ */ React.createElement(VIcon, { icon: item.props.prependIcon }))
                  });
                }),
                (_c = slots["append-item"]) == null ? void 0 : _c.call(slots)
              )
            ), model.value.map((item, index) => {
              function onChipClose(e) {
                e.stopPropagation();
                e.preventDefault();
                select(item, false);
              }
              const slotProps = {
                "onClick:close": onChipClose,
                onKeydown(e) {
                  if (e.key !== "Enter" && e.key !== " ")
                    return;
                  e.preventDefault();
                  e.stopPropagation();
                  onChipClose(e);
                },
                onMousedown(e) {
                  e.preventDefault();
                  e.stopPropagation();
                },
                modelValue: true,
                "onUpdate:modelValue": void 0
              };
              const hasSlot = hasChips ? !!slots.chip : !!slots.selection;
              const slotContent = hasSlot ? ensureValidVNode(
                hasChips ? slots.chip({ item, index, props: slotProps }) : slots.selection({ item, index })
              ) : void 0;
              if (hasSlot && !slotContent)
                return void 0;
              return /* @__PURE__ */ React.createElement("div", { key: item.value, class: "v-select__selection" }, hasChips ? !slots.chip ? /* @__PURE__ */ React.createElement(
                VChip,
                {
                  key: "chip",
                  closable: props.closableChips,
                  size: "small",
                  text: item.title,
                  disabled: item.props.disabled,
                  ...slotProps
                }
              ) : /* @__PURE__ */ React.createElement(
                VDefaultsProvider,
                {
                  key: "chip-defaults",
                  defaults: {
                    VChip: {
                      closable: props.closableChips,
                      size: "small",
                      text: item.title
                    }
                  }
                },
                slotContent
              ) : slotContent ?? /* @__PURE__ */ React.createElement("span", { class: "v-select__selection-text" }, item.title, props.multiple && index < model.value.length - 1 && /* @__PURE__ */ React.createElement("span", { class: "v-select__selection-comma" }, ",")));
            }));
          },
          "append-inner": (...args) => {
            var _a;
            return /* @__PURE__ */ React.createElement(React.Fragment, null, (_a = slots["append-inner"]) == null ? void 0 : _a.call(slots, ...args), props.menuIcon ? /* @__PURE__ */ React.createElement(
              VIcon,
              {
                class: "v-select__menu-icon",
                icon: props.menuIcon
              }
            ) : void 0);
          }
        }
      );
    });
    return forwardRefs({
      isFocused,
      menu,
      select
    }, vTextFieldRef);
  }
});
const defaultFilter = (value, query, item) => {
  if (value == null || query == null)
    return -1;
  return value.toString().toLocaleLowerCase().indexOf(query.toString().toLocaleLowerCase());
};
const makeFilterProps = propsFactory({
  customFilter: Function,
  customKeyFilter: Object,
  filterKeys: [Array, String],
  filterMode: {
    type: String,
    default: "intersection"
  },
  noFilter: Boolean
}, "filter");
function filterItems(items, query, options) {
  var _a;
  const array = [];
  const filter = (options == null ? void 0 : options.default) ?? defaultFilter;
  const keys = (options == null ? void 0 : options.filterKeys) ? wrapInArray(options.filterKeys) : false;
  const customFiltersLength = Object.keys((options == null ? void 0 : options.customKeyFilter) ?? {}).length;
  if (!(items == null ? void 0 : items.length))
    return array;
  loop:
    for (let i = 0; i < items.length; i++) {
      const [item, transformed = item] = wrapInArray(items[i]);
      const customMatches = {};
      const defaultMatches = {};
      let match = -1;
      if ((query || customFiltersLength > 0) && !(options == null ? void 0 : options.noFilter)) {
        if (typeof item === "object") {
          const filterKeys = keys || Object.keys(transformed);
          for (const key of filterKeys) {
            const value = getPropertyFromItem(transformed, key);
            const keyFilter = (_a = options == null ? void 0 : options.customKeyFilter) == null ? void 0 : _a[key];
            match = keyFilter ? keyFilter(value, query, item) : filter(value, query, item);
            if (match !== -1 && match !== false) {
              if (keyFilter)
                customMatches[key] = match;
              else
                defaultMatches[key] = match;
            } else if ((options == null ? void 0 : options.filterMode) === "every") {
              continue loop;
            }
          }
        } else {
          match = filter(item, query, item);
          if (match !== -1 && match !== false) {
            defaultMatches.title = match;
          }
        }
        const defaultMatchesLength = Object.keys(defaultMatches).length;
        const customMatchesLength = Object.keys(customMatches).length;
        if (!defaultMatchesLength && !customMatchesLength)
          continue;
        if ((options == null ? void 0 : options.filterMode) === "union" && customMatchesLength !== customFiltersLength && !defaultMatchesLength)
          continue;
        if ((options == null ? void 0 : options.filterMode) === "intersection" && (customMatchesLength !== customFiltersLength || !defaultMatchesLength))
          continue;
      }
      array.push({ index: i, matches: { ...defaultMatches, ...customMatches } });
    }
  return array;
}
function useFilter(props, items, query, options) {
  const filteredItems = ref([]);
  const filteredMatches = ref(/* @__PURE__ */ new Map());
  const transformedItems = computed(() => (options == null ? void 0 : options.transform) ? unref(items).map((item) => [item, options.transform(item)]) : unref(items));
  watchEffect(() => {
    const _query = typeof query === "function" ? query() : unref(query);
    const strQuery = typeof _query !== "string" && typeof _query !== "number" ? "" : String(_query);
    const results = filterItems(
      transformedItems.value,
      strQuery,
      {
        customKeyFilter: {
          ...props.customKeyFilter,
          ...unref(options == null ? void 0 : options.customKeyFilter)
        },
        default: props.customFilter,
        filterKeys: props.filterKeys,
        filterMode: props.filterMode,
        noFilter: props.noFilter
      }
    );
    const originalItems = unref(items);
    const _filteredItems = [];
    const _filteredMatches = /* @__PURE__ */ new Map();
    results.forEach(({ index, matches }) => {
      const item = originalItems[index];
      _filteredItems.push(item);
      _filteredMatches.set(item.value, matches);
    });
    filteredItems.value = _filteredItems;
    filteredMatches.value = _filteredMatches;
  });
  function getMatches(item) {
    return filteredMatches.value.get(item.value);
  }
  return { filteredItems, filteredMatches, getMatches };
}
function highlightResult(text, matches, length) {
  if (matches == null)
    return text;
  if (Array.isArray(matches))
    throw new Error("Multiple matches is not implemented");
  return typeof matches === "number" && ~matches ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { class: "v-autocomplete__unmask" }, text.substr(0, matches)), /* @__PURE__ */ React.createElement("span", { class: "v-autocomplete__mask" }, text.substr(matches, length)), /* @__PURE__ */ React.createElement("span", { class: "v-autocomplete__unmask" }, text.substr(matches + length))) : text;
}
const makeVAutocompleteProps = propsFactory({
  autoSelectFirst: {
    type: [Boolean, String]
  },
  clearOnSelect: Boolean,
  search: String,
  ...makeFilterProps({ filterKeys: ["title"] }),
  ...makeSelectProps(),
  ...omit(makeVTextFieldProps({
    modelValue: null,
    role: "combobox"
  }), ["validationValue", "dirty", "appendInnerIcon"]),
  ...makeTransitionProps({ transition: false })
}, "VAutocomplete");
genericComponent()({
  name: "VAutocomplete",
  props: makeVAutocompleteProps(),
  emits: {
    "update:focused": (focused) => true,
    "update:search": (value) => true,
    "update:modelValue": (value) => true,
    "update:menu": (value) => true
  },
  setup(props, { slots }) {
    const { t } = useLocale();
    const vTextFieldRef = ref();
    const isFocused = shallowRef(false);
    const isPristine = shallowRef(true);
    const listHasFocus = shallowRef(false);
    const vMenuRef = ref();
    const vVirtualScrollRef = ref();
    const _menu = useProxiedModel(props, "menu");
    const menu = computed({
      get: () => _menu.value,
      set: (v) => {
        var _a;
        if (_menu.value && !v && ((_a = vMenuRef.value) == null ? void 0 : _a.ΨopenChildren))
          return;
        _menu.value = v;
      }
    });
    const selectionIndex = shallowRef(-1);
    const color = computed(() => {
      var _a;
      return (_a = vTextFieldRef.value) == null ? void 0 : _a.color;
    });
    const label = computed(() => menu.value ? props.closeText : props.openText);
    const { items, transformIn, transformOut } = useItems(props);
    const { textColorClasses, textColorStyles } = useTextColor(color);
    const search = useProxiedModel(props, "search", "");
    const model = useProxiedModel(
      props,
      "modelValue",
      [],
      (v) => transformIn(v === null ? [null] : wrapInArray(v)),
      (v) => {
        const transformed = transformOut(v);
        return props.multiple ? transformed : transformed[0] ?? null;
      }
    );
    const counterValue = computed(() => {
      return typeof props.counterValue === "function" ? props.counterValue(model.value) : typeof props.counterValue === "number" ? props.counterValue : model.value.length;
    });
    const form = useForm();
    const { filteredItems, getMatches } = useFilter(props, items, () => isPristine.value ? "" : search.value);
    const displayItems = computed(() => {
      if (props.hideSelected) {
        return filteredItems.value.filter((filteredItem) => !model.value.some((s) => s.value === filteredItem.value));
      }
      return filteredItems.value;
    });
    const hasChips = computed(() => !!(props.chips || slots.chip));
    const hasSelectionSlot = computed(() => hasChips.value || !!slots.selection);
    const selectedValues = computed(() => model.value.map((selection) => selection.props.value));
    const highlightFirst = computed(() => {
      var _a;
      const selectFirst = props.autoSelectFirst === true || props.autoSelectFirst === "exact" && search.value === ((_a = displayItems.value[0]) == null ? void 0 : _a.title);
      return selectFirst && displayItems.value.length > 0 && !isPristine.value && !listHasFocus.value;
    });
    const menuDisabled = computed(() => props.hideNoData && !displayItems.value.length || props.readonly || (form == null ? void 0 : form.isReadonly.value));
    const listRef = ref();
    const { onListScroll, onListKeydown } = useScrolling(listRef, vTextFieldRef);
    function onClear(e) {
      if (props.openOnClear) {
        menu.value = true;
      }
      search.value = "";
    }
    function onMousedownControl() {
      if (menuDisabled.value)
        return;
      menu.value = true;
    }
    function onMousedownMenuIcon(e) {
      if (menuDisabled.value)
        return;
      if (isFocused.value) {
        e.preventDefault();
        e.stopPropagation();
      }
      menu.value = !menu.value;
    }
    function onKeydown(e) {
      var _a, _b, _c;
      if (props.readonly || (form == null ? void 0 : form.isReadonly.value))
        return;
      const selectionStart = vTextFieldRef.value.selectionStart;
      const length = model.value.length;
      if (selectionIndex.value > -1 || ["Enter", "ArrowDown", "ArrowUp"].includes(e.key)) {
        e.preventDefault();
      }
      if (["Enter", "ArrowDown"].includes(e.key)) {
        menu.value = true;
      }
      if (["Escape"].includes(e.key)) {
        menu.value = false;
      }
      if (highlightFirst.value && e.key === "Enter") {
        select(displayItems.value[0]);
      }
      if (e.key === "ArrowDown" && highlightFirst.value) {
        (_a = listRef.value) == null ? void 0 : _a.focus("next");
      }
      if (["Backspace", "Delete"].includes(e.key)) {
        if (!props.multiple && hasSelectionSlot.value && model.value.length > 0 && !search.value)
          return select(model.value[0], false);
        if (~selectionIndex.value) {
          const originalSelectionIndex = selectionIndex.value;
          select(model.value[selectionIndex.value], false);
          selectionIndex.value = originalSelectionIndex >= length - 1 ? length - 2 : originalSelectionIndex;
        } else if (e.key === "Backspace" && !search.value) {
          selectionIndex.value = length - 1;
        }
      }
      if (!props.multiple)
        return;
      if (e.key === "ArrowLeft") {
        if (selectionIndex.value < 0 && selectionStart > 0)
          return;
        const prev = selectionIndex.value > -1 ? selectionIndex.value - 1 : length - 1;
        if (model.value[prev]) {
          selectionIndex.value = prev;
        } else {
          selectionIndex.value = -1;
          vTextFieldRef.value.setSelectionRange((_b = search.value) == null ? void 0 : _b.length, (_c = search.value) == null ? void 0 : _c.length);
        }
      }
      if (e.key === "ArrowRight") {
        if (selectionIndex.value < 0)
          return;
        const next = selectionIndex.value + 1;
        if (model.value[next]) {
          selectionIndex.value = next;
        } else {
          selectionIndex.value = -1;
          vTextFieldRef.value.setSelectionRange(0, 0);
        }
      }
    }
    function onChange(e) {
      if (matchesSelector(vTextFieldRef.value, ":autofill") || matchesSelector(vTextFieldRef.value, ":-webkit-autofill")) {
        const item = items.value.find((item2) => item2.title === e.target.value);
        if (item) {
          select(item);
        }
      }
    }
    function onAfterLeave() {
      var _a;
      if (isFocused.value) {
        isPristine.value = true;
        (_a = vTextFieldRef.value) == null ? void 0 : _a.focus();
      }
    }
    function onFocusin(e) {
      isFocused.value = true;
      setTimeout(() => {
        listHasFocus.value = true;
      });
    }
    function onFocusout(e) {
      listHasFocus.value = false;
    }
    function onUpdateModelValue(v) {
      if (v == null || v === "" && !props.multiple && !hasSelectionSlot.value)
        model.value = [];
    }
    const isSelecting = shallowRef(false);
    function select(item, set = true) {
      if (!item || item.props.disabled)
        return;
      if (props.multiple) {
        const index = model.value.findIndex((selection) => props.valueComparator(selection.value, item.value));
        const add = set == null ? !~index : set;
        if (~index) {
          const value = add ? [...model.value, item] : [...model.value];
          value.splice(index, 1);
          model.value = value;
        } else if (add) {
          model.value = [...model.value, item];
        }
        if (props.clearOnSelect) {
          search.value = "";
        }
      } else {
        const add = set !== false;
        model.value = add ? [item] : [];
        search.value = add && !hasSelectionSlot.value ? item.title : "";
        nextTick(() => {
          menu.value = false;
          isPristine.value = true;
        });
      }
    }
    watch(isFocused, (val, oldVal) => {
      var _a;
      if (val === oldVal)
        return;
      if (val) {
        isSelecting.value = true;
        search.value = props.multiple || hasSelectionSlot.value ? "" : String(((_a = model.value.at(-1)) == null ? void 0 : _a.props.title) ?? "");
        isPristine.value = true;
        nextTick(() => isSelecting.value = false);
      } else {
        if (!props.multiple && search.value == null)
          model.value = [];
        else if (highlightFirst.value && !listHasFocus.value && !model.value.some(({ value }) => value === displayItems.value[0].value)) {
          select(displayItems.value[0]);
        }
        menu.value = false;
        if (props.multiple || hasSelectionSlot.value)
          search.value = "";
        selectionIndex.value = -1;
      }
    });
    watch(search, (val) => {
      if (!isFocused.value || isSelecting.value)
        return;
      if (val)
        menu.value = true;
      isPristine.value = !val;
    });
    watch(menu, () => {
      if (!props.hideSelected && menu.value && model.value.length) {
        const index = displayItems.value.findIndex(
          (item) => model.value.some((s) => item.value === s.value)
        );
        IN_BROWSER && window.requestAnimationFrame(() => {
          var _a;
          index >= 0 && ((_a = vVirtualScrollRef.value) == null ? void 0 : _a.scrollToIndex(index));
        });
      }
    });
    watch(() => props.items, (newVal, oldVal) => {
      if (menu.value)
        return;
      if (isFocused.value && !oldVal.length && newVal.length) {
        menu.value = true;
      }
    });
    useRender(() => {
      const hasList = !!(!props.hideNoData || displayItems.value.length || slots["prepend-item"] || slots["append-item"] || slots["no-data"]);
      const isDirty = model.value.length > 0;
      const textFieldProps = VTextField.filterProps(props);
      return /* @__PURE__ */ React.createElement(
        VTextField,
        {
          ref: vTextFieldRef,
          ...textFieldProps,
          "v-model": search.value,
          "onUpdate:modelValue": onUpdateModelValue,
          "v-model:focused": isFocused.value,
          validationValue: model.externalValue,
          counterValue: counterValue.value,
          dirty: isDirty,
          onChange,
          class: [
            "v-autocomplete",
            `v-autocomplete--${props.multiple ? "multiple" : "single"}`,
            {
              "v-autocomplete--active-menu": menu.value,
              "v-autocomplete--chips": !!props.chips,
              "v-autocomplete--selection-slot": !!hasSelectionSlot.value,
              "v-autocomplete--selecting-index": selectionIndex.value > -1
            },
            props.class
          ],
          style: props.style,
          readonly: props.readonly,
          placeholder: isDirty ? void 0 : props.placeholder,
          "onClick:clear": onClear,
          "onMousedown:control": onMousedownControl,
          onKeydown
        },
        {
          ...slots,
          default: () => {
            var _a, _b, _c;
            return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
              VMenu,
              {
                ref: vMenuRef,
                "v-model": menu.value,
                activator: "parent",
                contentClass: "v-autocomplete__content",
                disabled: menuDisabled.value,
                eager: props.eager,
                maxHeight: 310,
                openOnClick: false,
                closeOnContentClick: false,
                transition: props.transition,
                onAfterLeave,
                ...props.menuProps
              },
              hasList && /* @__PURE__ */ React.createElement(
                VList,
                {
                  ref: listRef,
                  selected: selectedValues.value,
                  selectStrategy: props.multiple ? "independent" : "single-independent",
                  onMousedown: (e) => e.preventDefault(),
                  onKeydown: onListKeydown,
                  onFocusin,
                  onFocusout,
                  onScrollPassive: onListScroll,
                  tabindex: "-1",
                  "aria-live": "polite",
                  color: props.itemColor ?? props.color,
                  ...props.listProps
                },
                (_a = slots["prepend-item"]) == null ? void 0 : _a.call(slots),
                !displayItems.value.length && !props.hideNoData && (((_b = slots["no-data"]) == null ? void 0 : _b.call(slots)) ?? /* @__PURE__ */ React.createElement(VListItem, { title: t(props.noDataText) })),
                /* @__PURE__ */ React.createElement(VVirtualScroll, { ref: vVirtualScrollRef, renderless: true, items: displayItems.value }, ({ item, index, itemRef }) => {
                  var _a2;
                  const itemProps = mergeProps(item.props, {
                    ref: itemRef,
                    key: index,
                    active: highlightFirst.value && index === 0 ? true : void 0,
                    onClick: () => select(item, null)
                  });
                  return ((_a2 = slots.item) == null ? void 0 : _a2.call(slots, {
                    item,
                    index,
                    props: itemProps
                  })) ?? /* @__PURE__ */ React.createElement(VListItem, { ...itemProps, role: "option" }, {
                    prepend: ({ isSelected }) => /* @__PURE__ */ React.createElement(React.Fragment, null, props.multiple && !props.hideSelected ? /* @__PURE__ */ React.createElement(
                      VCheckboxBtn,
                      {
                        key: item.value,
                        modelValue: isSelected,
                        ripple: false,
                        tabindex: "-1"
                      }
                    ) : void 0, item.props.prependAvatar && /* @__PURE__ */ React.createElement(VAvatar, { image: item.props.prependAvatar }), item.props.prependIcon && /* @__PURE__ */ React.createElement(VIcon, { icon: item.props.prependIcon })),
                    title: () => {
                      var _a3, _b2;
                      return isPristine.value ? item.title : highlightResult(item.title, (_a3 = getMatches(item)) == null ? void 0 : _a3.title, ((_b2 = search.value) == null ? void 0 : _b2.length) ?? 0);
                    }
                  });
                }),
                (_c = slots["append-item"]) == null ? void 0 : _c.call(slots)
              )
            ), model.value.map((item, index) => {
              function onChipClose(e) {
                e.stopPropagation();
                e.preventDefault();
                select(item, false);
              }
              const slotProps = {
                "onClick:close": onChipClose,
                onKeydown(e) {
                  if (e.key !== "Enter" && e.key !== " ")
                    return;
                  e.preventDefault();
                  e.stopPropagation();
                  onChipClose(e);
                },
                onMousedown(e) {
                  e.preventDefault();
                  e.stopPropagation();
                },
                modelValue: true,
                "onUpdate:modelValue": void 0
              };
              const hasSlot = hasChips.value ? !!slots.chip : !!slots.selection;
              const slotContent = hasSlot ? ensureValidVNode(
                hasChips.value ? slots.chip({ item, index, props: slotProps }) : slots.selection({ item, index })
              ) : void 0;
              if (hasSlot && !slotContent)
                return void 0;
              return /* @__PURE__ */ React.createElement(
                "div",
                {
                  key: item.value,
                  class: [
                    "v-autocomplete__selection",
                    index === selectionIndex.value && [
                      "v-autocomplete__selection--selected",
                      textColorClasses.value
                    ]
                  ],
                  style: index === selectionIndex.value ? textColorStyles.value : {}
                },
                hasChips.value ? !slots.chip ? /* @__PURE__ */ React.createElement(
                  VChip,
                  {
                    key: "chip",
                    closable: props.closableChips,
                    size: "small",
                    text: item.title,
                    disabled: item.props.disabled,
                    ...slotProps
                  }
                ) : /* @__PURE__ */ React.createElement(
                  VDefaultsProvider,
                  {
                    key: "chip-defaults",
                    defaults: {
                      VChip: {
                        closable: props.closableChips,
                        size: "small",
                        text: item.title
                      }
                    }
                  },
                  slotContent
                ) : slotContent ?? /* @__PURE__ */ React.createElement("span", { class: "v-autocomplete__selection-text" }, item.title, props.multiple && index < model.value.length - 1 && /* @__PURE__ */ React.createElement("span", { class: "v-autocomplete__selection-comma" }, ","))
              );
            }));
          },
          "append-inner": (...args) => {
            var _a;
            return /* @__PURE__ */ React.createElement(React.Fragment, null, (_a = slots["append-inner"]) == null ? void 0 : _a.call(slots, ...args), props.menuIcon ? /* @__PURE__ */ React.createElement(
              VIcon,
              {
                class: "v-autocomplete__menu-icon",
                icon: props.menuIcon,
                onMousedown: onMousedownMenuIcon,
                onClick: noop,
                "aria-label": t(label.value),
                title: t(label.value),
                tabindex: "-1"
              }
            ) : void 0);
          }
        }
      );
    });
    return forwardRefs({
      isFocused,
      isPristine,
      menu,
      search,
      filteredItems,
      select
    }, vTextFieldRef);
  }
});
const makeMalarkeyContactSearchProps = propsFactory(
  {
    ...omit(makeVAutocompleteProps(), [
      "items",
      "itemTitle",
      "itemValue",
      "itemProps",
      "itemChildren",
      "noDataText"
    ])
  },
  "MalarkeyContactSearch"
);
const _sfc_main = defineComponent({
  name: "MalarkeyContactSearch",
  props: makeMalarkeyContactSearchProps(),
  components: {
    MalarkeyContactSearchItem
  },
  emits: [
    /**
     * Emitted when the input is focused
     * @param {boolean} focused - Whether the input is focused
     */
    "update:focused",
    /**
     * Emitted when the search value is updated
     * @param {any} value - The search value
     */
    "update:search",
    /**
     * Emitted when the selected item(s) are updated
     * @param {any} value - The selected item(s)
     */
    "update",
    /**
     * Emitted when the selected item(s) are updated
     * @param {any} value - The selected item(s)
     */
    "update:modelValue",
    /**
     * Emitted when the menu is opened or closed
     * @param {boolean} value - Whether the menu is open
     */
    "update:menu"
  ],
  setup(props, { emit }) {
    const { t } = boundUseI18n();
    const mounted = ref(false);
    onMounted(() => {
      mounted.value = true;
    });
    onBeforeUnmount(() => {
      mounted.value = false;
    });
    const identity = inject("identity");
    const opts = useDefaults(props, "MalarkeyContactSearch");
    const roster = computed(
      () => instance.value ? instance.value.roster.value : []
    );
    const items = computed(
      () => [...roster.value].map((i) => ({
        title: stringOr(
          i.name,
          stringOr(i.friendlyName, stringOr(i.identifier))
        ),
        value: i.identifier,
        props: {
          user: i
        }
      }))
    );
    const modelValue = getProxiedModelRef(props.modelValue, (v) => {
      emit("update:modelValue", v);
      emit("update", v);
    });
    const menu = getProxiedModelRef(props.menu, (v) => {
      emit("update:menu", v);
    });
    const search = getProxiedModelRef(props.search, (v) => {
      emit("update:search", v);
    });
    const disabled = computed(
      () => !mounted.value || !identity || !identity.identified.value || !instance.value || !instance.value.initialized.value || opts.disabled
    );
    const noDataText = computed(() => {
      switch (true) {
        case !mounted.value:
          return t("malarkeyContactSearch.noDataText.unready");
        case opts.disabled:
          return t("malarkeyContactSearch.noDataText.disabled");
        case ("string" === typeof search.value && search.value.trim().length > 0):
          return t("malarkeyContactSearch.noDataText.searching");
        default:
          return t("malarkeyContactSearch.noDataText.default");
      }
    });
    const bindings = computed(() => ({
      ...opts,
      disabled: disabled.value,
      class: ["malarkey-contact-search"],
      items: items.value,
      modelValue: modelValue.value,
      itemTitle: "title",
      itemValue: "value",
      itemProps: "props",
      menu: menu.value,
      search: search.value,
      noDataText: noDataText.value
    }));
    const onUpdateFocused = (focused) => {
      emit("update:focused", focused);
      return true;
    };
    const onUpdateSearch = (value) => {
      search.value = value;
    };
    const onUpdateModelValue = (value) => {
      modelValue.value = value;
    };
    const onUpdateMenu = (value) => {
      menu.value = value;
    };
    const itemsAreSelectable = computed(() => props.multiple);
    const isItemActive = (item) => {
      if (Array.isArray(modelValue.value)) {
        return modelValue.value.includes(item.value);
      } else {
        return modelValue.value === item.value;
      }
    };
    watch(
      () => disabled.value,
      (is) => {
        if (is) {
          modelValue.value = props.multiple ? [] : null;
        }
      },
      { immediate: true }
    );
    return {
      bindings,
      onUpdateModelValue,
      itemsAreSelectable,
      isItemActive,
      onUpdateFocused,
      onUpdateSearch,
      onUpdateMenu
    };
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MalarkeyContactSearchItem = resolveComponent("MalarkeyContactSearchItem");
  const _component_v_autocomplete = resolveComponent("v-autocomplete");
  return openBlock(), createBlock(_component_v_autocomplete, mergeProps({ ..._ctx.$props, ..._ctx.bindings }, {
    "onUpdate:modelValue": _ctx.onUpdateModelValue,
    "onUpdate:search": _ctx.onUpdateSearch,
    "onUpdate:focused": _ctx.onUpdateFocused,
    "onUpdate:menu": _ctx.onUpdateMenu
  }), createSlots({
    item: withCtx(({ item, props }) => [
      createVNode(_component_MalarkeyContactSearchItem, mergeProps(props, {
        selectable: _ctx.itemsAreSelectable,
        active: _ctx.isItemActive(item.raw)
      }), {
        append: withCtx((bindings) => [
          renderSlot(_ctx.$slots, "append-item", normalizeProps(guardReactiveProps(bindings)))
        ]),
        _: 2
      }, 1040, ["selectable", "active"])
    ]),
    _: 2
  }, [
    _ctx.$slots["append"] ? {
      name: "append",
      fn: withCtx((bindings) => [
        renderSlot(_ctx.$slots, "append", normalizeProps(guardReactiveProps(bindings)))
      ]),
      key: "0"
    } : void 0,
    _ctx.$slots["append-inner"] ? {
      name: "append-inner",
      fn: withCtx((bindings) => [
        renderSlot(_ctx.$slots, "append-inner", normalizeProps(guardReactiveProps(bindings)))
      ]),
      key: "1"
    } : void 0,
    _ctx.$slots["chip"] ? {
      name: "chip",
      fn: withCtx((bindings) => [
        renderSlot(_ctx.$slots, "chip", normalizeProps(guardReactiveProps(bindings)))
      ]),
      key: "2"
    } : void 0,
    _ctx.$slots["clear"] ? {
      name: "clear",
      fn: withCtx((bindings) => [
        renderSlot(_ctx.$slots, "clear", normalizeProps(guardReactiveProps(bindings)))
      ]),
      key: "3"
    } : void 0,
    _ctx.$slots["details"] ? {
      name: "details",
      fn: withCtx((bindings) => [
        renderSlot(_ctx.$slots, "details", normalizeProps(guardReactiveProps(bindings)))
      ]),
      key: "4"
    } : void 0,
    _ctx.$slots["label"] ? {
      name: "label",
      fn: withCtx((bindings) => [
        renderSlot(_ctx.$slots, "label", normalizeProps(guardReactiveProps(bindings)))
      ]),
      key: "5"
    } : void 0,
    _ctx.$slots["loader"] ? {
      name: "loader",
      fn: withCtx((bindings) => [
        renderSlot(_ctx.$slots, "loader", normalizeProps(guardReactiveProps(bindings)))
      ]),
      key: "6"
    } : void 0,
    _ctx.$slots["message"] ? {
      name: "message",
      fn: withCtx((bindings) => [
        renderSlot(_ctx.$slots, "message", normalizeProps(guardReactiveProps(bindings)))
      ]),
      key: "7"
    } : void 0,
    _ctx.$slots["no-data"] ? {
      name: "no-data",
      fn: withCtx(() => [
        renderSlot(_ctx.$slots, "no-data")
      ]),
      key: "8"
    } : void 0,
    _ctx.$slots["prepend"] ? {
      name: "prepend",
      fn: withCtx((bindings) => [
        renderSlot(_ctx.$slots, "prepend", normalizeProps(guardReactiveProps(bindings)))
      ]),
      key: "9"
    } : void 0,
    _ctx.$slots["prepend-inner"] ? {
      name: "prepend-inner",
      fn: withCtx((bindings) => [
        renderSlot(_ctx.$slots, "prepend-inner", normalizeProps(guardReactiveProps(bindings)))
      ]),
      key: "10"
    } : void 0,
    _ctx.$slots["selection"] ? {
      name: "selection",
      fn: withCtx((bindings) => [
        renderSlot(_ctx.$slots, "selection", normalizeProps(guardReactiveProps(bindings)))
      ]),
      key: "11"
    } : void 0
  ]), 1040, ["onUpdate:modelValue", "onUpdate:search", "onUpdate:focused", "onUpdate:menu"]);
}
const MalarkeyContactSearch = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "MalarkeyContactSearch.vue"]]);
export {
  MalarkeyContactSearch as default
};
//# sourceMappingURL=MalarkeyContactSearch.es.js.map
